// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-02T15:45:43.380Z
// Property: Skyline Farmers Market (ID: 6767906449166060)
// Collections: 25 amenities, 20 floorplans (live), 27 photos, 43 POIs, 2 reviews, 17 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449166060",
  "property_external_id": "2054560",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/skyline-farmers-market-dallas-tx/4tgqgsl/",
  "property_google_business_url": "https://www.google.com/maps/place/Skyline+Farmers+Market/data=!4m2!3m1!1s0x0:0x76befa319ed552b7?sa=X&ved=2ahUKEwjY8pL07LmSAxVMavUHHVdtCJQQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "37512844112",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "skyline-farmers-market",
  "property_name": "Skyline Farmers Market",
  "property_website_url": "https://www.skylinefarmersmarketapts.com/",
  "property_domain": "https://www.skylinefarmersmarketapts.com/",
  "property_address": "835 S Good Latimer Expy",
  "property_full_address": "835 S Good Latimer Expy, Dallas, TX 75226",
  "property_address_1": "835 S Good Latimer Expy",
  "property_address_2": null,
  "property_address_city": "Dallas",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "75226",
  "property_address_country": "US",
  "property_address_county": "Dallas County",
  "property_neighborhood_address": "Dallas Downtown Historic District",
  "property_address_latitude": "32.7779853",
  "property_address_longitude": "-96.7844186",
  "property_email": "skylinefm@weidner.com",
  "property_phone": "9726350967",
  "property_call_tracking_phone": "469-727-2911",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Skyline Farmers Market, where spacious open floor plans meet a vibrant community lifestyle in the heart of Dallas. Enjoy a serene Zen courtyard, a rooftop sky lounge with stunning skyline views, and ample amenities like EV charging and private garage parking. Your urban oasis awaits—explore our availability today!",
  "property_long_description": "Experience Luxury Living at Skyline Farmers Market ApartmentsWelcome to Skyline Farmers Market, an upscale apartment community located across from Dallas Farmers Market.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-4e86-70da-a098-acbbfb2bf068.webp",
  "property_featured_image_media": {
    "alt_text": "Living room and kitchen area in an apartment with a sofa, coffee table, and dining set.",
    "public_id": "019d01aa-4e86-70da-a098-acbbfb2bf068",
    "storage_key": "property/6767906449166060/019d01aa-4e86-70da-a098-acbbfb2bf068.webp",
    "width": 1536,
    "height": 1024
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "340",
  "property_year_built": "2016",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.70588235294117",
  "property_admin_fee": null,
  "property_application_fee": "85",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://skylinefarmersmarketapts.securecafe.com/onlineleasing/skyline-farmers-market0/floorplans.aspx",
  "property_resident_portal_url": "https://skylinefarmersmarketapts.securecafenet.com/residentservices/skyline-farmers-market0/userlogin",
  "property_apply_now_url": "https://skylinefarmersmarketapts.securecafe.com/onlineleasing/skyline-farmers-market0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-f3f6-718a-ad74-198de447e9b9.webp",
  "property_primary_logo_media": {
    "alt_text": "Skyline Farmers Market logo",
    "public_id": "019d01aa-f3f6-718a-ad74-198de447e9b9",
    "storage_key": "property/6767906449166060/019d01aa-f3f6-718a-ad74-198de447e9b9.webp",
    "width": 387,
    "height": 228
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ac-ba2e-743e-a8e5-0a91c9747ecf.webp",
  "property_secondary_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d01ac-ba2e-743e-a8e5-0a91c9747ecf",
    "storage_key": "property/6767906449166060/019d01ac-ba2e-743e-a8e5-0a91c9747ecf.webp",
    "width": 325,
    "height": 97
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019f81ab-9653-737f-93c2-4f5385f15026.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Skyline Farmers Market logo with a city skyline silhouette.",
    "public_id": "019f81ab-9653-737f-93c2-4f5385f15026",
    "storage_key": "property/6767906449166060/019f81ab-9653-737f-93c2-4f5385f15026.webp",
    "width": 1650,
    "height": 1044
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-f3f6-718a-ad74-198de447e9b9.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Skyline Farmers Market logo",
    "public_id": "019d01aa-f3f6-718a-ad74-198de447e9b9",
    "storage_key": "property/6767906449166060/019d01aa-f3f6-718a-ad74-198de447e9b9.webp",
    "width": 387,
    "height": 228
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#3d3f42",
  "property_secondary_color": "#fdb30a",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "600 - 1739",
  "property_sqft_min": "600",
  "property_sqft_max": "1739",
  "property_price_range": "1110 - 4055",
  "property_price_min": "1110",
  "property_price_max": "4055",
  "property_available_units": 38,
  "property_facebook_url": "https://www.facebook.com/skylinefarmersmarket/photos/d41d8cd9/122259748520175756/",
  "property_instagram_url": "https://www.instagram.com/skylinefarmersmarket/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJPw9emeaYToYRt1LVnjH6vnY",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": "https://www.tiktok.com/discover/skyline-farmers-market-dallas-texas",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Skyline Farmers Market",
  "property_home_romance_title": "Embrace a Life of Love in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Skyline Farmers Market in Dallas, TX, where modern living meets vibrant community life. Choose from spacious floor plans, enjoy an array of amenities like a serene Zen courtyard, fitness center, and pool. Our smoke-free community offers convenience with online services, EV charging, and on-site management for your ultimate comfort.",
  "property_home_floorplans_blurb": "Welcome to Skyline Farmers Market in vibrant Dallas, TX, where modern comfort meets urban convenience. Choose from stylish studio, one-bedroom, or spacious two-bedroom floor plans designed for your lifestyle. Ready to find your ideal home? Browse our available apartments today and elevate your living experience!",
  "property_home_gallery_blurb": "Imagine a tranquil retreat at Skyline Farmers Market in Dallas, TX, where spacious studio, one, and two-bedroom apartments await. Enjoy modern amenities like a fitness center, serene courtyards, and EV charging stations. Our smoke-free community offers convenience and style—picture yourself living here and embracing a vibrant lifestyle!",
  "property_home_neighborhood_blurb": "Nestled in the vibrant heart of Dallas, Skyline Farmers Market offers a variety of floor plans, from cozy studios to spacious two-bedrooms. Immerse yourself in the local culture as you stroll through nearby parks, trendy cafes, and farmers markets. Experience a community where every day feels like a new adventure!",
  "property_home_reviews_blurb": "Welcome to Skyline Farmers Market, where comfort meets convenience in the heart of Dallas! Our residents rave about the warm atmosphere and the attentive staff that make them feel at home. With easy access to local hot spots and a vibrant community, your ideal lifestyle awaits. Join us today!",
  "property_neighborhood_blurb": "Nestled in the heart of Dallas, Skyline Farmers Market offers more than just stylish studio and multi-bedroom apartments. Surround yourself with culture at the Dallas Museum of Art and soak in nature at the Dallas Arboretum. Uncover vibrant parks and educational gems like Southern Methodist University—an ideal hub for both relaxation and discovery.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Skyline Farmers Market in Dallas, vibrant living meets tranquil spaces. Enjoy our Zen courtyard with a fire pit, grab a coffee in the clubhouse, or unwind in the sky lounge featuring stunning city views. With spacious floor plans and a smoke-free environment, your ideal home awaits.",
  "property_applynow_blurb": "At Skyline Farmers Market in Dallas, experience sophisticated living with spacious floor plans, including studios, one, and two-bedroom apartments. Enjoy exceptional amenities like the Zen courtyard, inviting clubhouse, and stunning skyline views from the Sky Lounge. Embrace comfort and convenience in a smoke-free community. Lease your new home online today!",
  "property_contactus_blurb": "At Skyline Farmers Market in Dallas, we offer a variety of thoughtfully designed floor plans to suit your lifestyle, including cozy studios, spacious one-bedroom, and inviting two-bedroom apartments. Have questions about your future home? Reach out to our leasing team today – we’re here to help you find the perfect fit!",
  "property_faqs_blurb": "At Skyline Farmers Market in Dallas, we offer diverse floor plans, from cozy studios to spacious two-bedroom apartments, tailored for your lifestyle. Curious about our community? Browse our FAQs page for answers to your most pressing questions and learn more about what makes us a vibrant place to call home.",
  "property_floorplans_blurb": "At Skyline Farmers Market in vibrant Dallas, you’ll find the ideal living space tailored to your lifestyle. Choose from charming studio, spacious one-bedroom, or cozy two-bedroom options. Each floor plan is designed to enhance your home experience. Browse our available apartment homes and find your perfect fit today!",
  "property_gallery_blurb": "Picture yourself living at Skyline Farmers Market, where expansive floor plans meet stunning Dallas skyline views. Enjoy serene moments in our Zen courtyard, unwind at the sky lounge, or sip complimentary coffee in the clubhouse. With modern amenities and private yards, your dream lifestyle awaits in this exclusive, smoke-free community.",
  "property_interactivemap_blurb": "At Skyline Farmers Market in Dallas, choose from stylish studio, one-, or two-bedroom apartments designed for modern living. Enjoy luxurious amenities like a Zen courtyard, a sky lounge with dazzling city views, and spacious private yards. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Skyline Farmers Market in vibrant Dallas, TX, your home is a sanctuary for both you and your furry friends. Enjoy our spacious apartments and community gardens, where up to two pets can thrive. Experience an urban lifestyle that nurtures connection and creativity—right in the heart of the city.",
  "property_referafriend_blurb": "At Skyline Farmers Market in Dallas, our diverse floor plans—including cozy studios and spacious two-bedrooms—are perfect for every lifestyle. Invite a friend to share in the vibrant community atmosphere and enjoy all the local delights we offer. Great friends make great neighbors—refer a friend today and elevate your living experience!",
  "property_residentaccess_blurb": "At Skyline Farmers Market in Dallas, our thoughtfully designed floor plans, including studios, one, and two-bedroom apartments, cater to your lifestyle. Elevate your living experience—log into the resident portal to effortlessly pay rent, schedule maintenance, and enjoy community perks. Your vibrant Dallas life starts here!",
  "property_reviews_blurb": "At Skyline Farmers Market in Dallas, vibrant community living thrives! Our residents praise the friendly staff and convenient amenities, highlighting their experience: \"Everyone in the office is friendly and quick to help with any issues.\" Join a neighborhood that values comfort and camaraderie while enjoying direct access to local hotspots.",
  "property_created_at": "1750448045059",
  "property_scheduletour_blurb": "At Skyline Farmers Market in vibrant Dallas, choose from chic studio, spacious one-bedroom, or family-friendly two-bedroom apartments tailored to your lifestyle. Schedule a tour today and immerse yourself in urban living surrounded by fresh local vibes. Dive into our resident testimonials to see why they love calling Skyline home!",
  "property_thankyou_blurb": "Thank you for your interest in Skyline Farmers Market in vibrant Dallas! Our diverse floor plans, featuring cozy studios to spacious two-bedroom apartments, offer the perfect blend of style and comfort. Expect a prompt response from our team to help guide you to your ideal living space. ",
  "property_virtualtours_blurb": "Experience modern living at Skyline Farmers Market, where stylish studios, one, and two-bedroom apartments await you in vibrant Dallas, TX. Immerse yourself in our welcoming community and envision your new home—take a virtual tour today to see what makes us the ideal choice for your next chapter!",
  "property_copyright": "2025 All Rights Reserved. Skyline Farmers Market",
  "property_seo_title_home": "Skyline Farmers Market | Apartments in Dallas, TX",
  "property_seo_description_home": "Elevate your lifestyle at Skyline Farmers Market in Dallas! Enjoy luxe amenities, stylish floor plans, and a welcoming community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Dallas, Texas Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Skyline Farmers Market in Dallas! Choose from cozy studios to spacious two-bedroom plans. Browse our floor plans today!",
  "property_seo_title_amenities": "Amenities | Dallas, Texas Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Skyline Farmers Market in Dallas! Enjoy luxurious amenities, from a refreshing pool to a pet paradise. Your perfect home awaits.",
  "property_seo_title_gallery": "Gallery | Apartments in Dallas, Texas",
  "property_seo_description_gallery": "Elevate your lifestyle at Skyline Farmers Market in Dallas! With stunning floor plans and luxurious amenities, picture your perfect home today.",
  "property_seo_title_virtualtours": "Virtual Tours | Skyline Farmers Market Apartments",
  "property_seo_description_virtualtours": "Step into your future home at Skyline Farmers Market in Dallas! Take a virtual tour of our stylish studio, one, and two-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Maps | Skyline Farmers Market Apartments",
  "property_seo_description_interactivemap": "Explore our interactive map for available apartments. Schedule a tour today to see our studio, one & two-bedroom options with premium amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Dallas, Texas",
  "property_seo_description_neighborhood": "Uncover the vibrant Dallas scene around Skyline Farmers Market! From charming cafes to local parks, dive into the treasures just steps from your new home.",
  "property_seo_title_contact": "Contact Us | Skyline Farmers Market",
  "property_seo_description_contact": "Experience skyline views and vibrant living at Skyline Farmers Market in Dallas. Need info? Reach out to our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Dallas, Texas",
  "property_seo_description_faqs": "Find answers to your questions at Skyline Farmers Market in Dallas! Explore amenities, floor plans, and everything you need for your perfect apartment stay.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Dallas, Texas",
  "property_seo_description_reviews": "Experience life at Skyline Farmers Market in Dallas! Our residents rave about spacious floor plans, luxury amenities, and vibrant community vibes. Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Dallas, Texas",
  "property_seo_description_applynow": "Elevate your lifestyle at Skyline Farmers Market in Dallas! With stunning amenities and diverse floor plans, your dream home awaits. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Skyline Farmers Market",
  "property_seo_description_residentaccess": "Connect to your Skyline Farmers Market community! Access your resident portal to pay rent, schedule maintenance, and enjoy the best of Dallas living today!",
  "property_seo_title_referafriend": "Refer A Friend | Skyline Farmers Market",
  "property_seo_description_referafriend": "Turn friends into neighbors at Skyline Farmers Market! Refer a friend today and help them find their perfect home in vibrant Dallas. Join our community!",
  "property_seo_title_scheduletour": "Schedule a Tour | Skyline Farmers Market",
  "property_seo_description_scheduletour": "Step into comfort at Skyline Farmers Market! Schedule your tour today and experience modern living in the heart of Dallas. Your new home awaits!",
  "property_seo_title_privacy": "Privacy Policy | Skyline Farmers Market",
  "property_seo_description_privacy": "At Skyline Farmers Market in Dallas, your privacy matters. Learn how we protect your information and create a secure living experience.",
  "property_seo_title_accessibility": "Website Accessibility | Skyline Farmers Market",
  "property_seo_description_accessibility": "Experience seamless living at Skyline Farmers Market in Dallas. Our commitment to digital inclusion ensures everyone can access information with ease.",
  "property_seo_title_sitemap": "Sitemap | Skyline Farmers Market",
  "property_seo_description_sitemap": "Navigate through Skyline Farmers Market's sitemap to effortlessly discover your future home in Dallas. Your vibrant apartment lifestyle awaits!",
  "property_seo_title_thankyou": "Thank You | Skyline Farmers Market",
  "property_seo_description_thankyou": "Thank you for reaching out! A member of our Skyline Farmers Market team in Dallas will connect with you soon. Exciting living awaits just around the corner!",
  "property_seo_title_pets": "Pet Policy | Skyline Farmers Market",
  "property_seo_description_pets": "Skyline Farmers Market offers a pet-friendly community with events for pets. Learn about our breed restrictions, fees, & more!",
  "property_updated_at": "1791293622217",
  "amenities": [
    {
      "id": "ec_84ecf2d6a3cce10eaf060d54",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124237980",
      "title": "Clubhouse with Pool Views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f1c6ce658d49e3dc28510cea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124237981",
      "title": "Resort-style Pool Courtyard with Sun Deck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d99e2-088a-723f-aaee-9084bf672807.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style swimming pool with modern lounge chairs.",
        "public_id": "019d99e2-088a-723f-aaee-9084bf672807",
        "storage_key": "property/6767906449166060/019d99e2-088a-723f-aaee-9084bf672807.webp",
        "width": 2048,
        "height": 1365
      },
      "amenity_image_alt_text": "A swimming pool surrounded by white chairs and buildings.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a10fe30ee7ea685f3d1507ad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124237982",
      "title": "Poolside & Zen Courtyard Grilling and Social Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b5d77c802a8aeeb177705478",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124237987",
      "title": "Package Receiving Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_65015ccd0f9afe0d36e7956f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124237988",
      "title": "Garage Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a45e8c34c8cad46c5822f56a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124237992",
      "title": "Cutting-edge Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d99e2-09d2-75a3-92b9-8c77e121dfbc.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with treadmills, weight bench, squat rack, and dumbbell set.",
        "public_id": "019d99e2-09d2-75a3-92b9-8c77e121dfbc",
        "storage_key": "property/6767906449166060/019d99e2-09d2-75a3-92b9-8c77e121dfbc.webp",
        "width": 2048,
        "height": 1365
      },
      "amenity_image_alt_text": "A gym with a brick wall and a variety of equipment.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bef21e25ff419501785a4a4b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124237983",
      "title": "Zen Courtyard with Fire Pit",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-e4dd-7571-be38-9ff232373504.webp",
      "amenity_image_media": {
        "alt_text": "Courtyard with a modern fire pit and lounge chairs",
        "public_id": "019d01aa-e4dd-7571-be38-9ff232373504",
        "storage_key": "property/6767906449166060/019d01aa-e4dd-7571-be38-9ff232373504.webp",
        "width": 2048,
        "height": 1365
      },
      "amenity_image_alt_text": "A modern courtyard with a hot tub and chairs.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_583e8cf28a7fbbde75c1842a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124237984",
      "title": "Oversized Yard with Turf*",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7634bf4ab8d7bd7b72a2f7c6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124237985",
      "title": "Complimentary Coffee Bar (Clubhouse)",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca979ff9a668a007aec583ea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124237986",
      "title": "Sky Lounge (3rd Floor) with Dallas Skyline City Views",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-e188-77f7-a968-1985639522ae.webp",
      "amenity_image_media": {
        "alt_text": "Rooftop patio with seating and city skyline view at dusk",
        "public_id": "019d01aa-e188-77f7-a968-1985639522ae",
        "storage_key": "property/6767906449166060/019d01aa-e188-77f7-a968-1985639522ae.webp",
        "width": 2048,
        "height": 1365
      },
      "amenity_image_alt_text": "A patio with chairs and a table with a view of the city.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff1443d3500e91c2044463a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124237989",
      "title": "Private Garage Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-e474-779a-8983-5536ba99debb.webp",
      "amenity_image_media": {
        "alt_text": "Covered parking entrance with exit and entry only signs.",
        "public_id": "019d01aa-e474-779a-8983-5536ba99debb",
        "storage_key": "property/6767906449166060/019d01aa-e474-779a-8983-5536ba99debb.webp",
        "width": 2048,
        "height": 1365
      },
      "amenity_image_alt_text": "A building with a red sign that says \"EXIT\" is shown.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bdb25558e05f0e11c004b93a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124237990",
      "title": "Reserved Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17bab7fa73eb3671fccf2e91",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124237991",
      "title": "Electric Vehicle Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a09793f0190e091d655eef03",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124237993",
      "title": "On-Site Management & Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_803850e5d071ecb9ebac3e89",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124237994",
      "title": "Smoke Free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f0e446ac6c7e2a752c1bd42",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124237996",
      "title": "Online Payments Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b5c553add648f46796b359f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124237997",
      "title": "Online Service Requests (Work Orders) Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7065a9f3c7f8579570ee9a03",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124237998",
      "title": "Limited Access Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_020bbbf84b7bf0788439497e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "127883138",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69e530b77ed9d7742c8635ca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "127883137",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9dbf472f9e175dcd8530f187",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "127883136",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a19ccbf4bfd7402e9f86cc6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124237999",
      "title": "Elevator Access*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_98b966cd86465dd309a28cd7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124238000",
      "title": "Spacious Open Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-e199-7585-afb2-f02cc3958f90.webp",
      "amenity_image_media": {
        "alt_text": "Living room and kitchen area with modern decor and furniture",
        "public_id": "019d01aa-e199-7585-afb2-f02cc3958f90",
        "storage_key": "property/6767906449166060/019d01aa-e199-7585-afb2-f02cc3958f90.webp",
        "width": 2048,
        "height": 1365
      },
      "amenity_image_alt_text": "A modern living room with a glass coffee table and a dining table in the background.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d5fd605c292158d9b02c5a6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "124238002",
      "title": "Large Private Yards*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c35c1b2208643ea2bcfe322b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "yardi",
      "external_id": "127883145",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_bf83480cd456ac2d95809631",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-4e86-70da-a098-acbbfb2bf068.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area in an apartment with a sofa, coffee table, and dining set.",
        "public_id": "019d01aa-4e86-70da-a098-acbbfb2bf068",
        "storage_key": "property/6767906449166060/019d01aa-4e86-70da-a098-acbbfb2bf068.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living and kitchen area featuring a comfortable sofa, elegant coffee table, and modern dining set, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room and kitchen area in an apartment with a sofa, coffee table, and dining set.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (1).jpg"
    },
    {
      "id": "ec_e3ab27d03e796a654a913958",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-4e9a-707e-b240-341a733fc6aa.webp",
      "image_media": {
        "alt_text": "Modern living room and kitchen with bar seating.",
        "public_id": "019d01aa-4e9a-707e-b240-341a733fc6aa",
        "storage_key": "property/6767906449166060/019d01aa-4e9a-707e-b240-341a733fc6aa.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious living area flowing into a modern kitchen, complete with stainless steel appliances and bar seating, perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern living room and kitchen with bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (2).jpg"
    },
    {
      "id": "ec_75f2aa8105cc03b1948a41f4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-4e7a-7368-809c-a76880f9381a.webp",
      "image_media": {
        "alt_text": "Modern kitchen and dining area with island and stainless steel appliances.",
        "public_id": "019d01aa-4e7a-7368-809c-a76880f9381a",
        "storage_key": "property/6767906449166060/019d01aa-4e7a-7368-809c-a76880f9381a.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Enjoy cooking and dining in this beautifully appointed kitchen, featuring an island, ample cabinetry, and sleek stainless steel appliances.",
      "link": "false",
      "alt_text": "Modern kitchen and dining area with island and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (3).jpg"
    },
    {
      "id": "ec_25724c23fd8e526b85bdeb59",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-4e7a-7368-809c-a87ddd9218da.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and contemporary cabinetry.",
        "public_id": "019d01aa-4e7a-7368-809c-a87ddd9218da",
        "storage_key": "property/6767906449166060/019d01aa-4e7a-7368-809c-a87ddd9218da.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Step into this stunning kitchen, featuring sleek stainless steel appliances, elegant granite countertops, and ample cabinet space for all your culinary needs.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and contemporary cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (4).jpg"
    },
    {
      "id": "ec_c161009a982bbd69918868e6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-5a2e-72c8-a519-80c3db3a6411.webp",
      "image_media": {
        "alt_text": "Modern dining area with a round glass table and two green chairs, adjacent to a well-equipped kitchen.",
        "public_id": "019d01aa-5a2e-72c8-a519-80c3db3a6411",
        "storage_key": "property/6767906449166060/019d01aa-5a2e-72c8-a519-80c3db3a6411.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Enjoy a stylish dining experience in this modern apartment, featuring a sleek glass table and comfortable seating, perfect for intimate meals or entertaining guests.",
      "link": "false",
      "alt_text": "Modern dining area with a round glass table and two green chairs, adjacent to a well-equipped kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (5).jpg"
    },
    {
      "id": "ec_04b625014fdd6f867ad4e05d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-5a76-719a-9d3c-be542946d2f9.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white subway tile backsplash, and gray cabinetry.",
        "public_id": "019d01aa-5a76-719a-9d3c-be542946d2f9",
        "storage_key": "property/6767906449166060/019d01aa-5a76-719a-9d3c-be542946d2f9.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this sleek and modern kitchen, featuring stainless steel appliances, ample cabinet space, and a bright subway tile backsplash.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, white subway tile backsplash, and gray cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (6).jpg"
    },
    {
      "id": "ec_65b1a8872d64aa97e91a0158",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-5a76-719a-9d3c-c4a4d03d4647.webp",
      "image_media": {
        "alt_text": "A plush queen-size bed with white linens, striped throw blanket, and blue pillows, flanked by elegant mirrors and a dresser.",
        "public_id": "019d01aa-5a76-719a-9d3c-c4a4d03d4647",
        "storage_key": "property/6767906449166060/019d01aa-5a76-719a-9d3c-c4a4d03d4647.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a queen-size bed with plush bedding and stylish decor. A perfect sanctuary for rest and rejuvenation.",
      "link": "false",
      "alt_text": "A plush queen-size bed with white linens, striped throw blanket, and blue pillows, flanked by elegant mirrors and a dresser.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (7).jpg"
    },
    {
      "id": "ec_3fb48044ef9e40d47dcabc05",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-5b41-71fd-917b-95e25c33351c.webp",
      "image_media": {
        "alt_text": "Double vanity bathroom with a large mirror, walk-in closet, and separate toilet.",
        "public_id": "019d01aa-5b41-71fd-917b-95e25c33351c",
        "storage_key": "property/6767906449166060/019d01aa-5b41-71fd-917b-95e25c33351c.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, a separate toilet, and a large walk-in closet, offering ample storage and a luxurious feel.",
      "link": "false",
      "alt_text": "Double vanity bathroom with a large mirror, walk-in closet, and separate toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (8).jpg"
    },
    {
      "id": "ec_c24b9cc2a8623d632b0289b7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-67b0-76a2-90c6-df8af072cc76.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a king-size bed, ceiling fan, and abstract art.",
        "public_id": "019d01aa-67b0-76a2-90c6-df8af072cc76",
        "storage_key": "property/6767906449166060/019d01aa-67b0-76a2-90c6-df8af072cc76.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-size bed, a soothing color palette, and elegant decor.",
      "link": "false",
      "alt_text": "Cozy bedroom with a king-size bed, ceiling fan, and abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (9).jpg"
    },
    {
      "id": "ec_c6c78bdcb08bdccc13a50816",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-67b0-76a2-90c6-da04e9fc153d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, granite countertops, and modern cabinetry.",
        "public_id": "019d01aa-67b0-76a2-90c6-da04e9fc153d",
        "storage_key": "property/6767906449166060/019d01aa-67b0-76a2-90c6-da04e9fc153d.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience luxury in this modern bathroom, featuring a spacious double vanity with granite countertops and sleek cabinetry.",
      "link": "false",
      "alt_text": "Modern bathroom with double vanity, granite countertops, and modern cabinetry.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (10).jpg"
    },
    {
      "id": "ec_1b10fb7bfb9827e5e03fffab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-67ab-70ad-a7dc-ac1ed8b75efb.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and bathtub with a shower.",
        "public_id": "019d01aa-67ab-70ad-a7dc-ac1ed8b75efb",
        "storage_key": "property/6767906449166060/019d01aa-67ab-70ad-a7dc-ac1ed8b75efb.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious and modern bathroom featuring a granite-top vanity, a comfortable toilet, and a relaxing bathtub with a shower.",
      "link": "false",
      "alt_text": "Modern bathroom with a vanity, toilet, and bathtub with a shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (11).jpg"
    },
    {
      "id": "ec_b638d17cfde1d5a050ec6de6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-6810-7373-b74f-33329cbb0315.webp",
      "image_media": {
        "alt_text": "Spacious apartment complex gym with treadmills, ellipticals, stair climbers, and weight machines.",
        "public_id": "019d01aa-6810-7373-b74f-33329cbb0315",
        "storage_key": "property/6767906449166060/019d01aa-6810-7373-b74f-33329cbb0315.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with a variety of cardio and strength training machines for a complete workout.",
      "link": "false",
      "alt_text": "Spacious apartment complex gym with treadmills, ellipticals, stair climbers, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (12).jpg"
    },
    {
      "id": "ec_aff951f918da87a5863b4c4c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-738f-758c-8927-8a3410342b91.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, dumbbells, and a rowing machine. Mural says 'Create You.'",
        "public_id": "019d01aa-738f-758c-8927-8a3410342b91",
        "storage_key": "property/6767906449166060/019d01aa-738f-758c-8927-8a3410342b91.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of weight machines, free weights, and cardio equipment. The gym is adorned with an inspiring mural, promoting a healthy and active lifestyle.",
      "link": "false",
      "alt_text": "Gym with weight machines, dumbbells, and a rowing machine. Mural says 'Create You.'",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (13).jpg"
    },
    {
      "id": "ec_624f43c9c9a6d9f5a350e985",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-7351-7098-abe8-9e0f6cbafca1.webp",
      "image_media": {
        "alt_text": "Community lounge with ping pong table, seating, and pool view.",
        "public_id": "019d01aa-7351-7098-abe8-9e0f6cbafca1",
        "storage_key": "property/6767906449166060/019d01aa-7351-7098-abe8-9e0f6cbafca1.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy leisure activities in our community lounge, featuring a ping pong table, comfortable seating, and a view of the resort-style pool.",
      "link": "false",
      "alt_text": "Community lounge with ping pong table, seating, and pool view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (14).jpg"
    },
    {
      "id": "ec_db7d6bfc9b47bdc488cc492d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-747d-77b1-8d7e-a66e1d0c5ea8.webp",
      "image_media": {
        "alt_text": "Modern apartment community lounge with seating areas, tables, and a coffee bar.",
        "public_id": "019d01aa-747d-77b1-8d7e-a66e1d0c5ea8",
        "storage_key": "property/6767906449166060/019d01aa-747d-77b1-8d7e-a66e1d0c5ea8.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring comfortable seating, ample workspaces, and a convenient coffee bar.",
      "link": "false",
      "alt_text": "Modern apartment community lounge with seating areas, tables, and a coffee bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (15).jpg"
    },
    {
      "id": "ec_0a525db7f70b722c3a6c252e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-74b9-70f8-a589-503a977f16f4.webp",
      "image_media": {
        "alt_text": "Modern leasing office with leather seating, communal tables, and a large reception desk.",
        "public_id": "019d01aa-74b9-70f8-a589-503a977f16f4",
        "storage_key": "property/6767906449166060/019d01aa-74b9-70f8-a589-503a977f16f4.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Welcome to our stylish leasing office, featuring comfortable seating areas, workstations, and a modern reception desk designed for your convenience.",
      "link": "false",
      "alt_text": "Modern leasing office with leather seating, communal tables, and a large reception desk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (16).jpg"
    },
    {
      "id": "ec_4346f85101d939792aa86673",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-8186-77b8-979b-8fab810dabc0.webp",
      "image_media": {
        "alt_text": "Covered outdoor lounge area with seating and tables, facing apartment buildings.",
        "public_id": "019d01aa-8186-77b8-979b-8fab810dabc0",
        "storage_key": "property/6767906449166060/019d01aa-8186-77b8-979b-8fab810dabc0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish outdoor lounge, featuring comfortable seating, tables for gathering, and a connection to the vibrant community spaces.",
      "link": "false",
      "alt_text": "Covered outdoor lounge area with seating and tables, facing apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (17).jpg"
    },
    {
      "id": "ec_e1bea365276c872c91762526",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-845c-7388-ae81-eb554bd491f4.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with built-in lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019d01aa-845c-7388-ae81-eb554bd491f4",
        "storage_key": "property/6767906449166060/019d01aa-845c-7388-ae81-eb554bd491f4.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Dive into relaxation at our stunning outdoor swimming pool, featuring chic built-in loungers and ample space for soaking up the sun.",
      "link": "false",
      "alt_text": "Luxury swimming pool with built-in lounge chairs and umbrellas, surrounded by apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (18).jpg"
    },
    {
      "id": "ec_2291a8ed11cc363b04d6b5fa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-87c4-70df-9327-cc6874d0b494.webp",
      "image_media": {
        "alt_text": "Luxury apartment complex pool area with lounge chairs and umbrellas at dusk.",
        "public_id": "019d01aa-87c4-70df-9327-cc6874d0b494",
        "storage_key": "property/6767906449166060/019d01aa-87c4-70df-9327-cc6874d0b494.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a relaxing swim or lounge by the pool at our beautiful apartment community. Perfect for unwinding after a long day.",
      "link": "false",
      "alt_text": "Luxury apartment complex pool area with lounge chairs and umbrellas at dusk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (19).jpg"
    },
    {
      "id": "ec_ce5fc6cf1e0efe8038433e99",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-85c5-702e-9f4b-4c96326266a8.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool area with lounge chairs and umbrellas.",
        "public_id": "019d01aa-85c5-702e-9f4b-4c96326266a8",
        "storage_key": "property/6767906449166060/019d01aa-85c5-702e-9f4b-4c96326266a8.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy our stunning resort-style swimming pool, perfect for relaxing and unwinding under the sun. Featuring ample lounge chairs and chic umbrellas, it's your oasis in the city.",
      "link": "false",
      "alt_text": "Resort-style swimming pool area with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (20).jpg"
    },
    {
      "id": "ec_6bd207404e87354ebaa5316c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-8f67-77ec-ad13-8c5ec04c6287.webp",
      "image_media": {
        "alt_text": "Courtyard with a long rectangular pool and outdoor seating areas.",
        "public_id": "019d01aa-8f67-77ec-ad13-8c5ec04c6287",
        "storage_key": "property/6767906449166060/019d01aa-8f67-77ec-ad13-8c5ec04c6287.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and unwind in our beautiful courtyard, featuring a stunning pool and comfortable seating areas perfect for enjoying the outdoors.",
      "link": "false",
      "alt_text": "Courtyard with a long rectangular pool and outdoor seating areas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (21).jpg"
    },
    {
      "id": "ec_f18f34c35ca28d7dff8d8710",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-9064-77bc-abff-3dc6d6266862.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with city skyline view at dusk.",
        "public_id": "019d01aa-9064-77bc-abff-3dc6d6266862",
        "storage_key": "property/6767906449166060/019d01aa-9064-77bc-abff-3dc6d6266862.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax on our stunning rooftop lounge, featuring comfortable seating and panoramic city views. Perfect for evening gatherings or enjoying the sunset.",
      "link": "false",
      "alt_text": "Rooftop lounge area with city skyline view at dusk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (22).jpg"
    },
    {
      "id": "ec_55e24c0026dc280373fd5774",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-93e2-75db-8538-11f55c555e58.webp",
      "image_media": {
        "alt_text": "Courtyard with outdoor dining, umbrellas, and cornhole.",
        "public_id": "019d01aa-93e2-75db-8538-11f55c555e58",
        "storage_key": "property/6767906449166060/019d01aa-93e2-75db-8538-11f55c555e58.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy outdoor living in our community courtyard, complete with comfortable seating, shaded umbrellas, and fun games like cornhole.",
      "link": "false",
      "alt_text": "Courtyard with outdoor dining, umbrellas, and cornhole.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (23).jpg"
    },
    {
      "id": "ec_38343dc46e0c8709c606e94c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-93d6-71fa-bf95-ef8f9fe2c083.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with seating, tables, and a mural.",
        "public_id": "019d01aa-93d6-71fa-bf95-ef8f9fe2c083",
        "storage_key": "property/6767906449166060/019d01aa-93d6-71fa-bf95-ef8f9fe2c083.webp",
        "width": 1920,
        "height": 1440
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish rooftop lounge, perfect for socializing and enjoying the evening air. Features comfortable seating, dining areas, and vibrant artwork.",
      "link": "false",
      "alt_text": "Rooftop lounge area with seating, tables, and a mural.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (24).jpg"
    },
    {
      "id": "ec_0e44922eada67de027b72220",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-9c0b-76a8-ad87-d86978025ef1.webp",
      "image_media": {
        "alt_text": "Courtyard seating area with wicker chairs and a sectional sofa under a covered patio.",
        "public_id": "019d01aa-9c0b-76a8-ad87-d86978025ef1",
        "storage_key": "property/6767906449166060/019d01aa-9c0b-76a8-ad87-d86978025ef1.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy relaxing in our spacious courtyard, featuring comfortable seating and a covered patio area perfect for outdoor gatherings.",
      "link": "false",
      "alt_text": "Courtyard seating area with wicker chairs and a sectional sofa under a covered patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (25).jpg"
    },
    {
      "id": "ec_3d8544843b477f27a448346f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-9cff-7709-bbec-9115a6619e10.webp",
      "image_media": {
        "alt_text": "Mailroom with multiple rows of mailboxes and decorative posters on the wall.",
        "public_id": "019d01aa-9cff-7709-bbec-9115a6619e10",
        "storage_key": "property/6767906449166060/019d01aa-9cff-7709-bbec-9115a6619e10.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Convenient mailroom with secure individual mailboxes for residents. Features a stylish design with decorative posters and modern lighting.",
      "link": "false",
      "alt_text": "Mailroom with multiple rows of mailboxes and decorative posters on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (26).jpg"
    },
    {
      "id": "ec_2537f73c08a91332dcaec4de",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01aa-9fdd-7147-8e54-641b83188cd2.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick apartment building with balconies and surrounding green space.",
        "public_id": "019d01aa-9fdd-7147-8e54-641b83188cd2",
        "storage_key": "property/6767906449166060/019d01aa-9fdd-7147-8e54-641b83188cd2.webp",
        "width": 1920,
        "height": 1440
      },
      "title": "Community",
      "description": "An aerial view showcases the modern architecture of this apartment building, highlighting its brick facade, private balconies, and well-maintained communal grounds with lush green lawns.",
      "link": "false",
      "alt_text": "Exterior view of a brick apartment building with balconies and surrounding green space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/TX_Skyline_Farmers_Market_Favorites (27).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_0aeeca6e-6ceb-4ea9-8046-ae8ea96ef887",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Terry Black's Barbecue",
      "poi_type": "Restaurants",
      "poi_address": "3025 Main St, Dallas, TX 75226, USA",
      "poi_short_description": "Austin import famous for pit-smoked meats and homemade sides from 4th generation pitmasters.",
      "poi_long_description": "People say this barbecue restaurant serves delicious brisket, ribs, and sausage, with sides like mac and cheese, creamed corn, and green beans. They highlight the generous portions, the authentic Texas BBQ vibe, and the fast service. They also like the friendly staff and the option to take a pit tour.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-0492-76c6-916a-51c17c88f266.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-0492-76c6-916a-51c17c88f266",
        "storage_key": "property/6767906449166060/019d01ab-0492-76c6-916a-51c17c88f266.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.terryblacksbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14205402431883636363",
      "poi_item_slug": "terry-blacks-barbecue",
      "poi_latitude": "32.7848915",
      "poi_longitude": "-96.7799081",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 469-399-0081",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5c17-72b9-aa43-e36b4df73212.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5c17-72b9-aa43-e36b4df73212",
        "storage_key": "property/6767906449166060/019d01ab-5c17-72b9-aa43-e36b4df73212.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuQDvm1CZToYRi-7kkz-6I8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_c44de183-d0da-440f-9196-944c6d916e99",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Katy Trail Ice House",
      "poi_type": "Restaurants",
      "poi_address": "3127 Routh St, Dallas, TX 75201, USA",
      "poi_short_description": "Casual beer garden with a sports-centric atmosphere and a menu of bar eats such as quesadillas.",
      "poi_long_description": "People say this restaurant serves delicious burgers, brisket, and chicken salad sandwiches. They also highlight the fun, dog-friendly atmosphere, the large patio perfect for people-watching, and the strong margaritas.\n\nSome reviews mention the food can be greasy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-048c-74a9-b010-4ffd2ba76af7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-048c-74a9-b010-4ffd2ba76af7",
        "storage_key": "property/6767906449166060/019d01ab-048c-74a9-b010-4ffd2ba76af7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://katyicehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17265218605057176218",
      "poi_item_slug": "katy-trail-ice-house",
      "poi_latitude": "32.8007453",
      "poi_longitude": "-96.8074712",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 214-468-0600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5c17-72b9-aa43-e36b4df73212.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5c17-72b9-aa43-e36b4df73212",
        "storage_key": "property/6767906449166060/019d01ab-5c17-72b9-aa43-e36b4df73212.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGb1hmzOZToYRmvLlo9hgmu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1cdf119e-dec0-4a05-8ac4-db1ce1a8f1f9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "The Henry",
      "poi_type": "Restaurants",
      "poi_address": "2301 N Akard St Suite 250, Dallas, TX 75201, USA",
      "poi_short_description": "Industrial-chic hangout serving American plates including brunch, plus cocktails and rooftop seating.",
      "poi_long_description": "People say this restaurant serves delicious salmon, short rib potstickers, and brussels sprouts. They also highlight the attentive and friendly staff, and the classy atmosphere.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-03bc-760e-8aad-97e98fe317c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-03bc-760e-8aad-97e98fe317c1",
        "storage_key": "property/6767906449166060/019d01ab-03bc-760e-8aad-97e98fe317c1.webp",
        "width": 586,
        "height": 876
      },
      "poi_business_url": "https://www.thehenryrestaurant.com/locations/the-henry-dallas/?utm_source=Google&utm_medium=Organic&utm_campaign=Maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=15411151253648939494",
      "poi_item_slug": "the-henry",
      "poi_latitude": "32.7892021",
      "poi_longitude": "-96.8055857",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 972-677-9560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5c17-72b9-aa43-e36b4df73212.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5c17-72b9-aa43-e36b4df73212",
        "storage_key": "property/6767906449166060/019d01ab-5c17-72b9-aa43-e36b4df73212.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd0GlbLqZToYR5pmP1Wlo39U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_23a7f428-2fc4-4bfd-8691-86a0147ac990",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Pecan Lodge",
      "poi_type": "Restaurants",
      "poi_address": "2702 Main St, Dallas, TX 75226, USA",
      "poi_short_description": "Texas barbecue such as beef ribs, brisket, and banana pudding, served in a relaxed space.",
      "poi_long_description": "People say this barbecue restaurant serves delicious Texas barbecue, including brisket, pork ribs, and burnt ends. They highlight the generous portions, reasonable prices, and the lively, casual atmosphere with indoor and outdoor seating. They also like the friendly and efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-04e3-70af-8b35-62a75f472610.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-04e3-70af-8b35-62a75f472610",
        "storage_key": "property/6767906449166060/019d01ab-04e3-70af-8b35-62a75f472610.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.pecanlodge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8780066691137611247",
      "poi_item_slug": "pecan-lodge",
      "poi_latitude": "32.7836494",
      "poi_longitude": "-96.7838379",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 214-748-8900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5c17-72b9-aa43-e36b4df73212.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5c17-72b9-aa43-e36b4df73212",
        "storage_key": "property/6767906449166060/019d01ab-5c17-72b9-aa43-e36b4df73212.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGXYxd92YToYR7yV_BSMQ2Xk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_cbf1d9c0-afb2-4006-b4a3-094899d204e8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "San Martin Bakery and Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "3120 McKinney Ave, Dallas, TX 75204, USA",
      "poi_short_description": "Casual restaurant and bakery serving Latin American cuisine including breakfast and brunch options.",
      "poi_long_description": "People say this restaurant offers delicious chilaquiles, pastries, and handmade bread, with a great selection for breakfast, lunch, and dinner. They highlight the reasonable prices, authentic Guatemalan flavors, and cozy, welcoming atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-0877-760f-9957-2d3757b65ec2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-0877-760f-9957-2d3757b65ec2",
        "storage_key": "property/6767906449166060/019d01ab-0877-760f-9957-2d3757b65ec2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://sanmartinbakery.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13612974738015358054",
      "poi_item_slug": "san-martin-bakery-and-restaurant",
      "poi_latitude": "32.8021821",
      "poi_longitude": "-96.79992070000002",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-802-6652",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5c17-72b9-aa43-e36b4df73212.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5c17-72b9-aa43-e36b4df73212",
        "storage_key": "property/6767906449166060/019d01ab-5c17-72b9-aa43-e36b4df73212.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD_FuypuZToYRZozFS2YA67w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_cb09d558-509e-44fe-aa92-0a3baed9ad3a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Central Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "5750 E Lovers Ln, Dallas, TX 75206, USA",
      "poi_short_description": "Gourmet grocery store offering produce, prepared foods, and seafood, as well as cooking classes.",
      "poi_long_description": "People say this gourmet grocery store offers a wide variety of fresh produce, high-quality meats and seafood, and gourmet items. They highlight the fantastic bakery, deli, and coffee selection, as well as the clean and organized shopping experience. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-09e6-750e-9f97-db6969138464.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-09e6-750e-9f97-db6969138464",
        "storage_key": "property/6767906449166060/019d01ab-09e6-750e-9f97-db6969138464.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.centralmarket.com/locations/dallas-lovers-lane?utm_source=google&utm_medium=organic&utm_campaign=cm_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=12147552457782087627",
      "poi_item_slug": "central-market",
      "poi_latitude": "32.849502",
      "poi_longitude": "-96.768635",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 214-234-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5d0d-7200-9402-7102875afbc1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5d0d-7200-9402-7102875afbc1",
        "storage_key": "property/6767906449166060/019d01ab-5d0d-7200-9402-7102875afbc1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyTaCZXWfToYRy0-GkJnGlKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_52ea4378-3a1e-4fab-9e5a-7e6a1b3d784e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "6110 Lemmon Ave, Dallas, TX 75209, USA",
      "poi_short_description": "Chain home improvement store carrying tools, appliances, building materials, and outdoor furniture.",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-0a12-7128-ab56-af5f41ac34c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-0a12-7128-ab56-af5f41ac34c9",
        "storage_key": "property/6767906449166060/019d01ab-0a12-7128-ab56-af5f41ac34c9.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/Lemmon-Avenue/TX/Dallas/75209/589?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9700471252875319679",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "32.8339511",
      "poi_longitude": "-96.8281363",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 214-654-9939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5c1b-7750-8773-f1b712fbad3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5c1b-7750-8773-f1b712fbad3d",
        "storage_key": "property/6767906449166060/019d01ab-5c1b-7750-8773-f1b712fbad3d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8bDxv5ueToYRf5mFjTX_noY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_7b8f0770-a425-4353-a79a-eee2bd6c7f22",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2510 McKinney Ave, Dallas, TX 75201, USA",
      "poi_short_description": "Grocery chain featuring organic produce, prepared foods, coffee, flowers, and vegan options.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, prepackaged salads, and a hot food bar with options like jalapeno cornbread and soup. They highlight the clean and well-stocked store, and the convenient location with complimentary parking and access to public transportation. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-0ae9-7740-942e-9bc8875bf0af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-0ae9-7740-942e-9bc8875bf0af",
        "storage_key": "property/6767906449166060/019d01ab-0ae9-7740-942e-9bc8875bf0af.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/uptowndallas?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=2836622873227843908",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "32.7959367",
      "poi_longitude": "-96.8016409",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-518-5814",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5d0d-7200-9402-7102875afbc1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5d0d-7200-9402-7102875afbc1",
        "storage_key": "property/6767906449166060/019d01ab-5d0d-7200-9402-7102875afbc1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Qepyi-ZToYRRFl-YHm1XSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b592d166-00e7-4a38-9068-ef3c1df02026",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Highland Park Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "47 Highland Park Village, Dallas, TX 75205, USA",
      "poi_short_description": "Outdoor center offering upscale fashion and lifestyle boutiques, plus restaurants.",
      "poi_long_description": "People say this shopping center offers a wide variety of high-end boutiques, designer stores, and restaurants. They highlight the beautiful, walkable outdoor setting, especially during the holiday season with festive decorations and lights, and the unique, charming atmosphere. They also like the attentive staff and personalized service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-0fab-74a0-848b-97d629714c62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-0fab-74a0-848b-97d629714c62",
        "storage_key": "property/6767906449166060/019d01ab-0fab-74a0-848b-97d629714c62.webp",
        "width": 1280,
        "height": 736
      },
      "poi_business_url": "https://hpvillage.com/?utm_source=local&utm_medium=organic&utm_campaign=GBP",
      "poi_directions_map_url": "https://maps.google.com/?cid=10672371025894939984",
      "poi_item_slug": "highland-park-village",
      "poi_latitude": "32.8356649",
      "poi_longitude": "-96.8056735",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 214-443-9898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5c1b-7750-8773-f1b712fbad3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5c1b-7750-8773-f1b712fbad3d",
        "storage_key": "property/6767906449166060/019d01ab-5c1b-7750-8773-f1b712fbad3d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJR3xmR-6eToYRUJ2jRefgG5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_80917d85-943a-414a-bef5-5d5d1cf4cb0d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Half Price Books",
      "poi_type": "Shopping & Retail",
      "poi_address": "5803 E NW Hwy, Dallas, TX 75231, USA",
      "poi_short_description": "Used bookstore chain outlet with a large selection of books and used music including vinyl records, plus coffee.",
      "poi_long_description": "People say this bookstore offers a massive selection of books, comics, vinyl records, movies, collectibles, and more, with a dedicated kids' section and a cafe. They highlight the great prices, the fun and inspiring vibe, and the comfortable reading areas. They also like the friendly, helpful, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-0f82-77cc-a093-3f0b22cb4159.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-0f82-77cc-a093-3f0b22cb4159",
        "storage_key": "property/6767906449166060/019d01ab-0f82-77cc-a093-3f0b22cb4159.webp",
        "width": 615,
        "height": 346
      },
      "poi_business_url": "https://www.hpb.com/store?storeid=HPB-001&showMap=true&horizontalView=true&isForm=true&y_source=1_MTExNTM3Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12441111906511058622",
      "poi_item_slug": "half-price-books",
      "poi_latitude": "32.866231",
      "poi_longitude": "-96.764778",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 214-379-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5c1b-7750-8773-f1b712fbad3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5c1b-7750-8773-f1b712fbad3d",
        "storage_key": "property/6767906449166060/019d01ab-5c1b-7750-8773-f1b712fbad3d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5cQZ6MmfToYRvnZ59ly1p6w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_9e0e5b8f-aa56-4ee2-80bf-2b616f204723",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Southern Methodist University",
      "poi_type": "Education",
      "poi_address": "Dallas, TX 75205, USA",
      "poi_short_description": "Private research school known for business & law & home to the George W. Bush Presidential Center.",
      "poi_long_description": "Private research school known for business & law & home to the George W. Bush Presidential Center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-12b5-7368-bcad-5c6914123d3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-12b5-7368-bcad-5c6914123d3e",
        "storage_key": "property/6767906449166060/019d01ab-12b5-7368-bcad-5c6914123d3e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.smu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13862021070155502638",
      "poi_item_slug": "southern-methodist-university",
      "poi_latitude": "32.8412178",
      "poi_longitude": "-96.7845175",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 214-768-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5d38-75af-9427-3cfa4c06bf20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5d38-75af-9427-3cfa4c06bf20",
        "storage_key": "property/6767906449166060/019d01ab-5d38-75af-9427-3cfa4c06bf20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFU7ARwSfToYRLlSZG7jKX8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5912fbcf-7bcb-4ab3-abd5-49462446b267",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Texas Woman's University",
      "poi_type": "Education",
      "poi_address": "5500 Southwestern Medical Ave, Dallas, TX 75235, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-12a6-743c-9b53-1647efe561ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-12a6-743c-9b53-1647efe561ac",
        "storage_key": "property/6767906449166060/019d01ab-12a6-743c-9b53-1647efe561ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.twu.edu/dallas",
      "poi_directions_map_url": "https://maps.google.com/?cid=13101283211414671610",
      "poi_item_slug": "texas-womans-university",
      "poi_latitude": "32.8125757",
      "poi_longitude": "-96.8467112",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 214-689-7750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5d38-75af-9427-3cfa4c06bf20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5d38-75af-9427-3cfa4c06bf20",
        "storage_key": "property/6767906449166060/019d01ab-5d38-75af-9427-3cfa4c06bf20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkaF7JBCcToYR-hApzqob0bU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e067c2c9-1795-47d2-a0e4-85f93cdd444d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "J. Erik Jonsson Central Library",
      "poi_type": "Education",
      "poi_address": "1515 Young St, Dallas, TX 75201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-15b3-7548-90ba-0501d64bff43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-15b3-7548-90ba-0501d64bff43",
        "storage_key": "property/6767906449166060/019d01ab-15b3-7548-90ba-0501d64bff43.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "http://dallaslibrary2.org/central/index.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=3928048277605030949",
      "poi_item_slug": "j-erik-jonsson-central-library",
      "poi_latitude": "32.7787125",
      "poi_longitude": "-96.7968662",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 214-670-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5d38-75af-9427-3cfa4c06bf20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5d38-75af-9427-3cfa4c06bf20",
        "storage_key": "property/6767906449166060/019d01ab-5d38-75af-9427-3cfa4c06bf20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_bAHzx6ZToYRJZw7xxg7gzY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_41240c1b-4880-4c71-bc8c-f29080251a63",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Dallas College El Centro Campus",
      "poi_type": "Education",
      "poi_address": "801 Main St, Dallas, TX 75202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-180a-7249-ad8e-7ead72c0fa28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-180a-7249-ad8e-7ead72c0fa28",
        "storage_key": "property/6767906449166060/019d01ab-180a-7249-ad8e-7ead72c0fa28.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.dallascollege.edu/pages/default.aspx?utm_source=local&utm_medium=organic&utm_campaign=gmb&utm_content=ecc",
      "poi_directions_map_url": "https://maps.google.com/?cid=16599254427695228294",
      "poi_item_slug": "dallas-college-el-centro-campus",
      "poi_latitude": "32.77976",
      "poi_longitude": "-96.805331",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 214-860-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5d38-75af-9427-3cfa4c06bf20.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5d38-75af-9427-3cfa4c06bf20",
        "storage_key": "property/6767906449166060/019d01ab-5d38-75af-9427-3cfa4c06bf20.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg5V_sBeZToYRhqUak_RlXOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b5eb3a23-a0e9-4a7a-adeb-caf18b60c0dd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Fondren Library",
      "poi_type": "Education",
      "poi_address": "6414 Robert S Hyer Ln, Dallas, TX 75205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-1972-73db-9cc2-d88ea0860fe1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-1972-73db-9cc2-d88ea0860fe1",
        "storage_key": "property/6767906449166060/019d01ab-1972-73db-9cc2-d88ea0860fe1.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.smu.edu/fondren",
      "poi_directions_map_url": "https://maps.google.com/?cid=6504469316197093010",
      "poi_item_slug": "fondren-library",
      "poi_latitude": "32.8443041",
      "poi_longitude": "-96.783386",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 214-768-2329",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5f29-775c-8e50-8ba75059954a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5f29-775c-8e50-8ba75059954a",
        "storage_key": "property/6767906449166060/019d01ab-5f29-775c-8e50-8ba75059954a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz3mo0QWfToYRkg5bhGGERFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_cec335ee-e171-4473-8fd2-d43d393c77fa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "American Airlines Center",
      "poi_type": "Entertainment",
      "poi_address": "2500 Victory Ave, Dallas, TX 75219, USA",
      "poi_short_description": "Home court of the Mavericks basketball and Stars hockey teams, this spot also hosts concerts and other events.",
      "poi_long_description": "People say this arena offers a variety of events, including basketball games, concerts, and circuses. They highlight the electric atmosphere, especially during playoff games, and the excellent sound quality for concerts. They also like the friendly and helpful staff, and the clean facilities. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-1972-73db-9cc2-d4b61d9897d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-1972-73db-9cc2-d4b61d9897d0",
        "storage_key": "property/6767906449166060/019d01ab-1972-73db-9cc2-d4b61d9897d0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.americanairlinescenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2405235901812051875",
      "poi_item_slug": "american-airlines-center",
      "poi_latitude": "32.7903908",
      "poi_longitude": "-96.8102547",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5f6c-70ad-8769-858d856c4126",
        "storage_key": "property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr-XOXC-ZToYRow-GKE8dYSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_05e59496-fb30-4cf0-ba12-aa2d903851ee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "The Dallas World Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "1801 N Griffin St, Dallas, TX 75202, USA",
      "poi_short_description": "Featuring rainforest and underwater exhibits, this venue showcases exotic birds, fish, and mammals.",
      "poi_long_description": "People say this aquarium offers a diverse range of animals, including birds, fish, reptiles, and mammals, and features a shark tunnel and a manatee exhibit. They also highlight the beautiful, immersive rainforest environment, the friendly and helpful staff, and the fun, family-friendly atmosphere.\n\nSome reviews mention there can be large crowds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-1c82-70ee-8e2c-b1c12c8929a7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-1c82-70ee-8e2c-b1c12c8929a7",
        "storage_key": "property/6767906449166060/019d01ab-1c82-70ee-8e2c-b1c12c8929a7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dwazoo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1754665305414928610",
      "poi_item_slug": "the-dallas-world-aquarium",
      "poi_latitude": "32.7834737",
      "poi_longitude": "-96.805358",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 214-720-2224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5f6c-70ad-8769-858d856c4126",
        "storage_key": "property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_8GjDj2ZToYR4oj1dMzSWRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_69451f7f-16e1-445a-9fd5-76b27de9c679",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Dallas Zoo",
      "poi_type": "Entertainment",
      "poi_address": "650 S R.L. Thornton Fwy, Dallas, TX 75203, USA",
      "poi_short_description": "Opened in 1888, this 106-acre park features more than 2,000 animals across 400 species.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including elephants, giraffes, and big cats, and provides opportunities for animal encounters like giraffe feeding. They highlight the affordable membership, which includes perks like unlimited rides on the carousel and train, and the family-friendly atmosphere. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-1fe0-7408-affd-68ad9eaf2a17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-1fe0-7408-affd-68ad9eaf2a17",
        "storage_key": "property/6767906449166060/019d01ab-1fe0-7408-affd-68ad9eaf2a17.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.dallaszoo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16225131918522501330",
      "poi_item_slug": "dallas-zoo",
      "poi_latitude": "32.7409696",
      "poi_longitude": "-96.81532",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 469-554-7501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5f6c-70ad-8769-858d856c4126",
        "storage_key": "property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgaB_eJaZToYR0shi9YM_K-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_a8005f06-a28b-4444-bd9e-05cbab4dc9d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Perot Museum of Nature and Science",
      "poi_type": "Entertainment",
      "poi_address": "2201 N Field St, Dallas, TX 75201, USA",
      "poi_short_description": "Five floors of hands-on exhibits on subjects such as dinosaurs, outer space, and human biology.",
      "poi_long_description": "People say this science museum offers a wide range of exhibits, including dinosaur fossils, gems, minerals, and interactive displays, as well as a 3D movie and a children's museum. They highlight the membership is worth the price and provides access to other museums, and the museum is a fun and educational experience for families. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-1fca-703f-b2e2-1d5dc982d2bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-1fca-703f-b2e2-1d5dc982d2bd",
        "storage_key": "property/6767906449166060/019d01ab-1fca-703f-b2e2-1d5dc982d2bd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.perotmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18406171203775046302",
      "poi_item_slug": "perot-museum-of-nature-and-science",
      "poi_latitude": "32.7869429",
      "poi_longitude": "-96.8065844",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 214-428-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-60c6-75af-bd15-4643f2b400f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-60c6-75af-bd15-4643f2b400f3",
        "storage_key": "property/6767906449166060/019d01ab-60c6-75af-bd15-4643f2b400f3.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ5o-djyZToYRniIJlDDbb_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_46eb0cad-df29-4833-82cc-e9044cd621e5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Dallas Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "1717 N Harwood St, Dallas, TX 75201, USA",
      "poi_short_description": "Free-admission museum showcasing art from around the world, including African, European, and Islamic pieces, plus live performances.",
      "poi_long_description": "People say this art museum offers a diverse collection of art, including African art, modern art, and paintings, as well as special exhibits. They highlight the free admission, the educational and relaxing experience, and the beautiful and well-laid-out galleries. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-201e-7622-8445-5914144620b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-201e-7622-8445-5914144620b6",
        "storage_key": "property/6767906449166060/019d01ab-201e-7622-8445-5914144620b6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dma.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=500356134714668464",
      "poi_item_slug": "dallas-museum-of-art",
      "poi_latitude": "32.7876959",
      "poi_longitude": "-96.8010444",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 214-922-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-60c6-75af-bd15-4643f2b400f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-60c6-75af-bd15-4643f2b400f3",
        "storage_key": "property/6767906449166060/019d01ab-60c6-75af-bd15-4643f2b400f3.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJe8S3giSZToYRsPXa5kCf8QY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_4b7dcc11-f796-4eb1-b554-f3b99cb5c955",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "5910 N Central Expy, Dallas, TX 75206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-21c5-70a0-98b3-ce8782bb5e6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-21c5-70a0-98b3-ce8782bb5e6a",
        "storage_key": "property/6767906449166060/019d01ab-21c5-70a0-98b3-ce8782bb5e6a.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/tx/dallas-highland-park.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=4667365949014014149",
      "poi_item_slug": "life-time",
      "poi_latitude": "32.8386211",
      "poi_longitude": "-96.7752494",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 214-624-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5f6c-70ad-8769-858d856c4126",
        "storage_key": "property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2RHOlxGfToYRxfi7E5rQxUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e5c512e8-87ca-4172-a776-4a37ba027d11",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2690 N Haskell Ave., Dallas, TX 75204, USA",
      "poi_short_description": "Chain gym featuring a pool, basketball court, and state-of-the-art equipment, plus personal training.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and group fitness classes, and is clean and well-maintained.\n\nOther reviews mention the staff can be unhelpful and the equipment can be out of service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-265f-72aa-b767-72668294f7ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-265f-72aa-b767-72668294f7ec",
        "storage_key": "property/6767906449166060/019d01ab-265f-72aa-b767-72668294f7ec.webp",
        "width": 1080,
        "height": 1143
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=697&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=7595466955778861992",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "32.8067293",
      "poi_longitude": "-96.7906453",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 214-530-0005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5f6c-70ad-8769-858d856c4126",
        "storage_key": "property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ88oelyqfToYRqKtqKvSEaGk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_55cb2f79-577a-4166-8ff9-f65b9d7b5ebb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2300 Fort Worth Ave, Dallas, TX 75211, USA",
      "poi_short_description": "Chain fitness center with a pool, a sauna, and cardio and strength-training equipment, plus basketball.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-25ca-704e-8088-143227b7dbec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-25ca-704e-8088-143227b7dbec",
        "storage_key": "property/6767906449166060/019d01ab-25ca-704e-8088-143227b7dbec.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/dallas-tx/kessler-park-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=3316175344974805507",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "32.7591846",
      "poi_longitude": "-96.8600628",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 214-377-2559",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5f6c-70ad-8769-858d856c4126",
        "storage_key": "property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4SPDnn-bToYRA7ohCuhrBS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e528f816-e645-46a3-a36c-7313df19dbac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Cowboys Fit",
      "poi_type": "Health and Wellness",
      "poi_address": "411 N Washington Ave Ste 1900, Dallas, TX 75246, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this fitness center offers a wide range of equipment, a sauna, and a pool. They highlight the affordable membership options, the clean facilities, and the friendly staff. They also like the recovery amenities, including cryotherapy and a body scanner. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-26cb-7079-bf35-0448ba490804.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-26cb-7079-bf35-0448ba490804",
        "storage_key": "property/6767906449166060/019d01ab-26cb-7079-bf35-0448ba490804.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.cowboysfit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2182562495134448010",
      "poi_item_slug": "cowboys-fit",
      "poi_latitude": "32.7889193",
      "poi_longitude": "-96.7761321",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 214-446-7172",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5f6c-70ad-8769-858d856c4126",
        "storage_key": "property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH3s18cOYToYRijmUjgYFSh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_5a0effeb-3a08-4287-bb97-de55a368e0a5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Equinox Highland Park",
      "poi_type": "Health and Wellness",
      "poi_address": "4023 Oak Lawn Ave, Dallas, TX 75219, USA",
      "poi_short_description": "Membership-only gym chain offering innovative programs, spa services, and a swimming pool.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-26b5-736e-890f-9310784863d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-26b5-736e-890f-9310784863d1",
        "storage_key": "property/6767906449166060/019d01ab-26b5-736e-890f-9310784863d1.webp",
        "width": 1280,
        "height": 823
      },
      "poi_business_url": "https://www.equinox.com/clubs/texas/highlandpark-dallas?cid=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13120063404384267176",
      "poi_item_slug": "equinox-highland-park",
      "poi_latitude": "32.8178176",
      "poi_longitude": "-96.8030242",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 214-443-9009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5f6c-70ad-8769-858d856c4126",
        "storage_key": "property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgURGK8WeToYRqCvtOCfUE7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_67025696-9135-430c-b80f-08890d541997",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4800 Columbia Ave, Dallas, TX 75226, USA",
      "poi_short_description": "Chain gym offering a variety of equipment, classes, and tanning options, plus massage chairs.",
      "poi_long_description": "People say this gym has a friendly staff and is consistently clean with lots of equipment, including new machines for the calves, chest, and legs. They also highlight the great training staff and the convenient location with ample parking.\n\nSome reviews mention the equipment can be damaged.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-2b2c-75ca-9bc1-a2c10735fe67.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-2b2c-75ca-9bc1-a2c10735fe67",
        "storage_key": "property/6767906449166060/019d01ab-2b2c-75ca-9bc1-a2c10735fe67.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/dallas-columbia-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=16176074196194960766",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.7938915",
      "poi_longitude": "-96.7633835",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 214-216-0267",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5f6c-70ad-8769-858d856c4126",
        "storage_key": "property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-cNVOOqZToYRfiWQ5Mb1fOA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3e7c9c43-46ba-4e2f-943e-81fbadace749",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Children's Medical Center Dallas",
      "poi_type": "Health and Wellness",
      "poi_address": "1935 Medical District Dr, Dallas, TX 75235, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-31a3-74bf-9b54-a2c1d50d5530.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-31a3-74bf-9b54-a2c1d50d5530",
        "storage_key": "property/6767906449166060/019d01ab-31a3-74bf-9b54-a2c1d50d5530.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.childrens.com/locations/dallas-campus/childrens-medical-center-dallas?utm_source=google?utm_medium=yext&utm_campaign=Children's%20Medical%20Center%20Dallas%20%7C%20%20%7C%20Brand",
      "poi_directions_map_url": "https://maps.google.com/?cid=18271839534167086103",
      "poi_item_slug": "childrens-medical-center-dallas",
      "poi_latitude": "32.8093936",
      "poi_longitude": "-96.8368333",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 214-456-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-60d3-748a-8e02-e91d846ebb31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-60d3-748a-8e02-e91d846ebb31",
        "storage_key": "property/6767906449166060/019d01ab-60d3-748a-8e02-e91d846ebb31.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJTeFHSgKcToYRF9T3ej-dkv0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_7bc869f7-4ca7-424f-991e-da1b390a3de6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Parkland Health",
      "poi_type": "Health and Wellness",
      "poi_address": "5200 Harry Hines Blvd, Dallas, TX 75235, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-345a-752d-b70b-038f95104d2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-345a-752d-b70b-038f95104d2f",
        "storage_key": "property/6767906449166060/019d01ab-345a-752d-b70b-038f95104d2f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.parklandhealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8882318995387276974",
      "poi_item_slug": "parkland-health",
      "poi_latitude": "32.8127279",
      "poi_longitude": "-96.8358337",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 214-590-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-60d3-748a-8e02-e91d846ebb31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-60d3-748a-8e02-e91d846ebb31",
        "storage_key": "property/6767906449166060/019d01ab-60d3-748a-8e02-e91d846ebb31.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJO6FKVW6dToYRrl7D1RBWRHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_fa665111-913d-4722-8ae8-0b2c7b4ca23f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "The Dallas Arboretum and Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8525 Garland Rd, Dallas, TX 75218, USA",
      "poi_short_description": "66-acre botanical garden set on White Rock Lake with frequent concerts, special exhibits & classes.",
      "poi_long_description": "People say this botanical garden offers beautiful flowers, seasonal displays, and water features, including waterfalls and koi ponds. They highlight the relaxing, serene, and peaceful atmosphere, and the accessible paths suitable for wheelchairs. They also like the friendly and helpful staff, and the free wheelchair rentals. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-3473-746a-bfd2-8f8df082252a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-3473-746a-bfd2-8f8df082252a",
        "storage_key": "property/6767906449166060/019d01ab-3473-746a-bfd2-8f8df082252a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.dallasarboretum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7499498569549444674",
      "poi_item_slug": "the-dallas-arboretum-and-botanical-garden",
      "poi_latitude": "32.8236184",
      "poi_longitude": "-96.7166236",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 214-515-6615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-62ff-748a-b70e-625a107c5a09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-62ff-748a-b70e-625a107c5a09",
        "storage_key": "property/6767906449166060/019d01ab-62ff-748a-b70e-625a107c5a09.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRxtoZJqhToYRQnaLBzeSE2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_66585930-ef05-422c-add4-d874cba2e2e1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Klyde Warren Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2012 Woodall Rodgers Fwy, Dallas, TX 75201, USA",
      "poi_short_description": "Family-friendly park with a playground, picnic tables, a splash pad, and food trucks.",
      "poi_long_description": "People say this park offers a variety of activities, including a playground, splash pad, fountains, and ping pong tables, as well as food trucks and live music. They highlight the family-friendly atmosphere, the clean facilities, and the beautiful green space. They also like the relaxing and tranquil vibe, and the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-386f-714d-92cf-043e4d07b944.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-386f-714d-92cf-043e4d07b944",
        "storage_key": "property/6767906449166060/019d01ab-386f-714d-92cf-043e4d07b944.webp",
        "width": 1138,
        "height": 1280
      },
      "poi_business_url": "https://www.klydewarrenpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5785296695854485354",
      "poi_item_slug": "klyde-warren-park",
      "poi_latitude": "32.7893644",
      "poi_longitude": "-96.8016184",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 214-716-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-62ff-748a-b70e-625a107c5a09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-62ff-748a-b70e-625a107c5a09",
        "storage_key": "property/6767906449166060/019d01ab-62ff-748a-b70e-625a107c5a09.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZf6cwiSZToYRas-lbLGASVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_51b9bc83-33bc-4d64-a989-224a970c29b4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Fair Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3809 Grand Ave, Dallas, TX 75210, USA",
      "poi_short_description": "Sprawling complex housing cultural & sports facilities, an amusement park & a Vietnam memorial.",
      "poi_long_description": "People say this city park offers a variety of attractions, including an aquarium, museums, and gardens, as well as events like fireworks shows and festivals. They highlight the family-friendly atmosphere, the beautiful landscape design and architecture, and the many opportunities for walking and exploring. They also like the entertaining shows and the professional and courteous staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-3af4-704b-ad59-97149d893aed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-3af4-704b-ad59-97149d893aed",
        "storage_key": "property/6767906449166060/019d01ab-3af4-704b-ad59-97149d893aed.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.fairparkdallas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=451054701663654212",
      "poi_item_slug": "fair-park",
      "poi_latitude": "32.7782181",
      "poi_longitude": "-96.7592709",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 214-670-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-62ff-748a-b70e-625a107c5a09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-62ff-748a-b70e-625a107c5a09",
        "storage_key": "property/6767906449166060/019d01ab-62ff-748a-b70e-625a107c5a09.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ12JIoZeYToYRRJHugtx3QgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b1f3c201-9326-483e-a988-6954396e41bc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Dealey Plaza",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "400 Main St, Dallas, TX 75202, USA",
      "poi_short_description": "City park & National Historic Landmark where President John F. Kennedy was assassinated in 1963.",
      "poi_long_description": "People say this park is a historically significant landmark where a pivotal moment in history occurred. They highlight the informative markers and plaques, and the well-maintained grounds. They also like the surreal and reverent atmosphere, and the opportunity to learn about the past.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-3c3a-7556-9db2-dfd8178d7e20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-3c3a-7556-9db2-dfd8178d7e20",
        "storage_key": "property/6767906449166060/019d01ab-3c3a-7556-9db2-dfd8178d7e20.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dealeyplaza.jfk.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14962220142878040032",
      "poi_item_slug": "dealey-plaza",
      "poi_latitude": "32.7788184",
      "poi_longitude": "-96.8082993",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 214-670-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-62ff-748a-b70e-625a107c5a09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-62ff-748a-b70e-625a107c5a09",
        "storage_key": "property/6767906449166060/019d01ab-62ff-748a-b70e-625a107c5a09.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJOfYI1RWZToYR4J9wW_J7pM8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7dc35622-24d6-4837-a6c7-e6e5a9928286",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Pioneer Plaza",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1428 Young St, Dallas, TX 75202, USA",
      "poi_short_description": "Park with bronze statues of Texas longhorns, cowboys, and a cattle drive, plus skyline views.",
      "poi_long_description": "People say this park features a collection of larger-than-life bronze statues depicting a cattle drive, showcasing longhorn steers and cowboys. They highlight the peaceful and relaxing atmosphere, and the beautiful setting with native Texas plants and a flowing stream. They also like the historical significance and the opportunity to take photos. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-3e24-77d6-ae76-f6c1044c9ab4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-3e24-77d6-ae76-f6c1044c9ab4",
        "storage_key": "property/6767906449166060/019d01ab-3e24-77d6-ae76-f6c1044c9ab4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.dallasparks.org/Facilities/Facility/Details/Pioneer-Plaza-624",
      "poi_directions_map_url": "https://maps.google.com/?cid=5378986228968264526",
      "poi_item_slug": "pioneer-plaza",
      "poi_latitude": "32.7766323",
      "poi_longitude": "-96.8011986",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-62ff-748a-b70e-625a107c5a09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-62ff-748a-b70e-625a107c5a09",
        "storage_key": "property/6767906449166060/019d01ab-62ff-748a-b70e-625a107c5a09.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6QFl8BmZToYRThNf5Xn_pUo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_66bb996f-5f93-4d1f-a780-bc123cb62d0b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Dallas Love Field",
      "poi_type": "Transportation & Transit",
      "poi_address": "8008 Herb Kelleher Way, Dallas, TX 75235, USA",
      "poi_short_description": "Airport featuring a variety of permanent & rotating artwork, including sculptures & paintings.",
      "poi_long_description": "People say this airport offers a variety of dining options, including local favorites and popular chains, and has a convenient layout with easy access to terminals, parking, and car rentals. They also highlight the quick service, efficient security lines, and friendly staff, as well as the clean and well-maintained facilities.\n\nOther reviews mention the ride-share pickup location can be far from baggage claim.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-3f56-70a5-ae58-5fa902c12e0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-3f56-70a5-ae58-5fa902c12e0b",
        "storage_key": "property/6767906449166060/019d01ab-3f56-70a5-ae58-5fa902c12e0b.webp",
        "width": 1280,
        "height": 427
      },
      "poi_business_url": "https://www.dallas-lovefield.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16894157064492491654",
      "poi_item_slug": "dallas-love-field",
      "poi_latitude": "32.8438345",
      "poi_longitude": "-96.8484951",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 214-670-5683",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-640e-7579-a9b3-ec89e84cd27a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-640e-7579-a9b3-ec89e84cd27a",
        "storage_key": "property/6767906449166060/019d01ab-640e-7579-a9b3-ec89e84cd27a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RIjmDScToYRhiO7UFcadOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_e2dfcae5-8eb6-47d9-87c0-e3da4101a173",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Akard",
      "poi_type": "Transportation & Transit",
      "poi_address": "Dallas, TX 75202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-4622-72fb-9d47-541c14401975.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-4622-72fb-9d47-541c14401975",
        "storage_key": "property/6767906449166060/019d01ab-4622-72fb-9d47-541c14401975.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dart.org/riding/stations/akardstation.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=7273346411654948223",
      "poi_item_slug": "akard",
      "poi_latitude": "32.78191",
      "poi_longitude": "-96.80052",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5f6c-70ad-8769-858d856c4126",
        "storage_key": "property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz8KaeBiZToYRfyUOiwYe8GQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_7b370d9d-8db1-4405-8fe6-2bdced255c19",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Pearl/Arts District Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Dallas, TX 75201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-4627-7528-a1ce-e421f59c87bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-4627-7528-a1ce-e421f59c87bc",
        "storage_key": "property/6767906449166060/019d01ab-4627-7528-a1ce-e421f59c87bc.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.dart.org/riding/stations/pearlartsdistrictstation.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=9991684355496389272",
      "poi_item_slug": "pearlarts-district-station",
      "poi_latitude": "32.7865115",
      "poi_longitude": "-96.7944538",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5f6c-70ad-8769-858d856c4126",
        "storage_key": "property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR58A6CCZToYRmKowrfuXqYo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_8905c231-c3a1-465f-bbc5-c3bb26520c78",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Fair Park Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Dallas, TX 75210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-45ff-76dd-bc72-727053595a01.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-45ff-76dd-bc72-727053595a01",
        "storage_key": "property/6767906449166060/019d01ab-45ff-76dd-bc72-727053595a01.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9799466227151497287",
      "poi_item_slug": "fair-park-station",
      "poi_latitude": "32.781959",
      "poi_longitude": "-96.766046",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5f6c-70ad-8769-858d856c4126",
        "storage_key": "property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF2O93JWYToYRR2jNIZ2y_oc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_39decc66-0568-472d-9439-2ab83406d436",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "St Paul Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Dallas, TX 75201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-47ba-747b-9772-322ba669c78e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-47ba-747b-9772-322ba669c78e",
        "storage_key": "property/6767906449166060/019d01ab-47ba-747b-9772-322ba669c78e.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6027887250791965099",
      "poi_item_slug": "st-paul-station",
      "poi_latitude": "32.784325",
      "poi_longitude": "-96.796951",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5f6c-70ad-8769-858d856c4126",
        "storage_key": "property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhUUuhSGZToYRq6GPeYRbp1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_e0431824-b6d6-487a-8d66-21c9a257782f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Dallas City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1500 Marilla St, Dallas, TX 75201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-4f14-750e-b62b-a593f9319913.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-4f14-750e-b62b-a593f9319913",
        "storage_key": "property/6767906449166060/019d01ab-4f14-750e-b62b-a593f9319913.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://dallascityhall.com/Pages/default.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4029763817868914858",
      "poi_item_slug": "dallas-city-hall",
      "poi_latitude": "32.7764068",
      "poi_longitude": "-96.7970783",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 214-670-3111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5f29-775c-8e50-8ba75059954a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5f29-775c-8e50-8ba75059954a",
        "storage_key": "property/6767906449166060/019d01ab-5f29-775c-8e50-8ba75059954a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0b-mARyZToYRqnDMfNeY7Dc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_52d6a2ac-307a-4c0d-b473-684d513791a5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Salesforce Dallas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2300 N Field St, Dallas, TX 75201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-4e3c-70cc-92f7-4e2ea661a792.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-4e3c-70cc-92f7-4e2ea661a792",
        "storage_key": "property/6767906449166060/019d01ab-4e3c-70cc-92f7-4e2ea661a792.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.salesforce.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10071358633735952301",
      "poi_item_slug": "salesforce-dallas",
      "poi_latitude": "32.7886931",
      "poi_longitude": "-96.8063299",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5f6c-70ad-8769-858d856c4126",
        "storage_key": "property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJO0RdOTuZToYRrRdlKVGnxIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_234d0971-4d1f-4373-aada-5d7301225ddc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Santander Tower",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1601 Elm St, Dallas, TX 75201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-4f7f-7266-9581-653a5b2389dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-4f7f-7266-9581-653a5b2389dd",
        "storage_key": "property/6767906449166060/019d01ab-4f7f-7266-9581-653a5b2389dd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.santandertower.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2195714571110441741",
      "poi_item_slug": "santander-tower",
      "poi_latitude": "32.7819723",
      "poi_longitude": "-96.7981211",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5f6c-70ad-8769-858d856c4126",
        "storage_key": "property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgyAuqBiZToYRDeMv38S-eB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ddeab8fe-4ea3-4750-bed4-0996a072b2d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "717 Harwood, Hilltop Tower",
      "poi_type": "Major Employers & Offices",
      "poi_address": "KPMG Centre, 717 N Harwood St, Dallas, TX 75201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-4e1c-74da-94c1-3d5a810b8018.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-4e1c-74da-94c1-3d5a810b8018",
        "storage_key": "property/6767906449166060/019d01ab-4e1c-74da-94c1-3d5a810b8018.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.hilltopsecurities.com/contact-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=7450125107903157603",
      "poi_item_slug": "717-harwood-hilltop-tower",
      "poi_latitude": "32.7853858",
      "poi_longitude": "-96.797949",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 214-730-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5f6c-70ad-8769-858d856c4126",
        "storage_key": "property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHZH6zyOZToYRY1XJLFApZGc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f31f1bcd-06a5-4009-9ccf-055a05b2311a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "poi_name": "Trammell Crow Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2001 Ross Ave, Dallas, TX 75201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-54ad-750b-94a4-f2d019ae7642.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01ab-54ad-750b-94a4-f2d019ae7642",
        "storage_key": "property/6767906449166060/019d01ab-54ad-750b-94a4-f2d019ae7642.webp",
        "width": 1280,
        "height": 794
      },
      "poi_business_url": "https://www.trammellcrowcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17283859668748459117",
      "poi_item_slug": "trammell-crow-center",
      "poi_latitude": "32.7876517",
      "poi_longitude": "-96.7996819",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 214-863-4147",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01ab-5f6c-70ad-8769-858d856c4126",
        "storage_key": "property/6767906449166060/019d01ab-5f6c-70ad-8769-858d856c4126.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf53FcCSZToYRbdxzf8ua3O8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_dec38bc69126e56d5bc93b6b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_a4be1c4b886a9881d3ba2237",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_18e5381d9a930c2f2b6dc83a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6f9c10cb1529661431abcccd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "day": "THU",
      "open_time": "10:30",
      "close_time": "18:00"
    },
    {
      "id": "ec_4cf739a850eea3e6d8bf754e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fba654a005e780393c839b72",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_98e01a5e2bfe08a81931f523",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "rating": "5",
      "name": "Dia",
      "text": "I just want to take a moment to thank Ivy and Luis for their kindness and professionalism. They truly listened to my concerns and went above and beyond to make sure I felt comfortable and happy in my home. It’s rare to find a team that genuinely cares. Their help made such a difference and reminded me why I love living here.\nIvy was so patient and understanding, she never made me feel like I was complaining and really focused on finding a solution. You can tell she genuinely cares about residents being happy and comfortable.\n\nLuis fixed everything that needed to fixed and very quick i love you at that. Before he left, he even took the time to ask if there were any other problems that needed attention, that small gesture really stood out to me. It showed how dedicated he is to making sure everything is taken care of.\n\nTogether, they made me feel heard, valued, and happy with where I live. It’s comforting to know there are people like Ivy and Luis who take pride in their work and truly care about residents.",
      "date": "2025-10-24",
      "title": "false"
    },
    {
      "id": "ec_f521ea2ed144eacfa1008bb3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "rating": "5",
      "name": "Katie Tate",
      "text": "This property is GOLDEN!!!!! You don’t get the chance to feel clean, safe, and at home many places in Dallas. Skyline is absolutely that place! The ladies in the front Aymieka and Alayna are the most helpful and whole hearted women. They are really the heart of the complex! Jonathan and Antonio are your maintenance guys here and go above and beyond with their fixing of all needs! Luis is beyond amazing and really keeps everyone in check… Ivy… mannnnnnn she just changed the entire complex around so fast to make it worth every single penny!! A warm and welcoming place to call home and I can’t wait to spend the rest of my holiday season here.",
      "date": "2025-10-27",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_96dcf68d-ac18-469e-9087-9af225c9fd29",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019fd3a2-83e8-70d6-a59e-865332b729f5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-83e8-70d6-a59e-865332b729f5",
        "storage_key": "property/6767906449166060/019fd3a2-83e8-70d6-a59e-865332b729f5.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "Pool Courtyard Tour",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=8FQBShJvt3Z&play=1"
    },
    {
      "id": "custom_b15f75bd-8432-4c32-a39e-d6ef7b6cfa3a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019fd3a2-83f7-7734-b6d9-317976e98835.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-83f7-7734-b6d9-317976e98835",
        "storage_key": "property/6767906449166060/019fd3a2-83f7-7734-b6d9-317976e98835.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "Sky Lounge Tour",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=8ZyHzbSWTy1&play=1"
    },
    {
      "id": "custom_9a7c67ef-5bdb-4500-b367-720928d6080d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019fd3a2-8a35-76d8-bdfc-6433c556a5c3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-8a35-76d8-bdfc-6433c556a5c3",
        "storage_key": "property/6767906449166060/019fd3a2-8a35-76d8-bdfc-6433c556a5c3.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "Zen Courtyard Tour",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=3Zw68MrFHHB&play=1"
    },
    {
      "id": "custom_b0053dbc-6df3-41c6-ab9d-f9494932b5b3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019fd3a2-8a44-728d-9f8c-019680150cf5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-8a44-728d-9f8c-019680150cf5",
        "storage_key": "property/6767906449166060/019fd3a2-8a44-728d-9f8c-019680150cf5.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "Clubhouse Tour",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=oDqJZr22vUF&play=1"
    },
    {
      "id": "custom_b34ea953-61db-462e-9a59-7cbfcaa22add",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019fd3a2-90d3-76ba-a146-55ec2031096d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-90d3-76ba-a146-55ec2031096d",
        "storage_key": "property/6767906449166060/019fd3a2-90d3-76ba-a146-55ec2031096d.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "Fitness Center Tour",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=h16U7YeJdzz&play=1"
    },
    {
      "id": "custom_90c5d22b-3bdd-4a3c-95e0-07f59a12053c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019fd3a2-935f-7419-9d9e-0a47658703a3.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-935f-7419-9d9e-0a47658703a3",
        "storage_key": "property/6767906449166060/019fd3a2-935f-7419-9d9e-0a47658703a3.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "Office Tour",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=enNwVM6BwhJ&play=1"
    },
    {
      "id": "custom_2e73b837-3d5f-4278-a290-53c0727673cc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Penthouse",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://www.zillow.com/view-imx/1f4038eb-4a83-499b-b0a0-a2c02dd7a77b?setAttribution=mls&wl=true&initialViewType=pano&utm_source=dashboard"
    },
    {
      "id": "custom_407cf3a1-01be-4771-803d-e83704e3b0c8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019fd3a2-9733-7680-a566-f24da379335f.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-9733-7680-a566-f24da379335f",
        "storage_key": "property/6767906449166060/019fd3a2-9733-7680-a566-f24da379335f.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "E1 | Studio | 600 SQ FT",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Lcem2MTbRHw&play=1"
    },
    {
      "id": "custom_43ee9dba-f90e-4a8a-9bc3-52a82cf332e6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "E2 | Studio 1B | 657 SQ FT",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://www.zillow.com/view-imx/73a9ea0b-5dd1-4244-8965-fc8db21a195a?setAttribution=mls&wl=true&initialViewType=pano&utm_source=dashboard"
    },
    {
      "id": "custom_14326bfd-d5b6-4d14-8baa-5e3e8f5fe79c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019fd3a2-9990-714d-80bd-3fce379aaeee.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-9990-714d-80bd-3fce379aaeee",
        "storage_key": "property/6767906449166060/019fd3a2-9990-714d-80bd-3fce379aaeee.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "A1 | 1 BD - 1 BA | 672 SQ FT",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=pLqHrtNoPZ9&play=1"
    },
    {
      "id": "custom_a08dd99f-2d89-4bd8-bf67-c7e9071e026d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019fd3a2-9d45-74ee-8dee-50ec99c62440.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-9d45-74ee-8dee-50ec99c62440",
        "storage_key": "property/6767906449166060/019fd3a2-9d45-74ee-8dee-50ec99c62440.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "A2 | 1 B - 1 BA | 720 SQ FT",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kwASvuWcq2k"
    },
    {
      "id": "custom_0dfb1ba1-35e8-4a82-af8b-92fbcaed98b1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019fd3a2-9f6b-7409-b89b-4e6dcb117566.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-9f6b-7409-b89b-4e6dcb117566",
        "storage_key": "property/6767906449166060/019fd3a2-9f6b-7409-b89b-4e6dcb117566.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "A3 | 1 BD - 1 BA | 736 SQ FT",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=JUF7ju9R7Dx&play=1"
    },
    {
      "id": "custom_d37633e2-538e-4a8a-9f0b-5a4e26d8ff9b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "A4 | 1B 1B | 750 SQ FT",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://www.zillow.com/view-imx/4c31da82-66dd-48a0-a9ce-85568caaa8cd?setAttribution=mls&wl=true&initialViewType=pano&utm_source=dashboard"
    },
    {
      "id": "custom_4e2c0950-fdd4-4efb-80a7-0aa44deb2efe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019fd3a2-a2f9-724b-bc04-fcbdb6a367ec.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-a2f9-724b-bc04-fcbdb6a367ec",
        "storage_key": "property/6767906449166060/019fd3a2-a2f9-724b-bc04-fcbdb6a367ec.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "A5 | 1 BD - 1 BA | 770 SQ FT",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5z8fvG7WDnV&play=1"
    },
    {
      "id": "custom_e0816599-b934-4b9c-b1f6-ca3c5db5fb3e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019fd3a2-a645-77c0-80c2-2daf5b85ff42.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-a645-77c0-80c2-2daf5b85ff42",
        "storage_key": "property/6767906449166060/019fd3a2-a645-77c0-80c2-2daf5b85ff42.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "B1 | 2 BD - 2 BA | 1107 SQ FT",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kXD1hec5FxJ&play=1"
    },
    {
      "id": "custom_93b632f9-61ea-426b-8c59-6ea24b924b19",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019fd3a2-a9a0-72ff-ad64-44946f217a54.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fd3a2-a9a0-72ff-ad64-44946f217a54",
        "storage_key": "property/6767906449166060/019fd3a2-a9a0-72ff-ad64-44946f217a54.webp",
        "width": 1920,
        "height": 1080
      },
      "virtual_tour_title": "B2 | 2 BD - 2 BA | 1116 SQ FT",
      "virtual_tour_type": "false",
      "virtual_tour_url": "https://my.matterport.com/show/?m=m4Nbf993gQX&play=1"
    },
    {
      "id": "custom_47594d9d-070c-4d39-8e6f-a919e035e213",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "B6 | 2B 2B | 1348 SQ FT",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://www.zillow.com/view-imx/73b84035-b362-42c8-bc20-715e0db83261?setAttribution=mls&wl=true&initialViewType=pano&utm_source=dashboard"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-d180-7399-b097-236350698f4b",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "skyline-farmers-market",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060"
    },
    {
      "lead_collector_id": "0198aa47-d1e1-761b-a7b4-792810c627cb",
      "lead_source": "FACEBOOK_ADS",
      "name": "skyline-farmers-market",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060"
    },
    {
      "lead_collector_id": "0198aa47-d246-777b-b3be-1baba7bbee5e",
      "lead_source": "LANDING_PAGE",
      "name": "skyline-farmers-market",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "resort-style-pool-apartments-dallas-downtown-historic-district",
      "search_query": "resort style pool apartments Dallas Downtown Historic District",
      "category": "Amenity",
      "h1_title": "Resort Style Pool Apartments in Downtown Dallas",
      "h2_subtitle": "Discover resort style pool apartments in the heart of Dallas Downtown Historic District. Enjoy luxury living with stunning amenities and vibrant views.",
      "page_copy": "Step into the vibrant lifestyle offered by our resort style pool apartments nestled within the Dallas Downtown Historic District. At Skyline Farmers Market, we combine luxury and convenience, bringing you closer to what Dallas has to offer. Our resort-style pool with an expansive sundeck is perfect for unwinding after a long day or soaking up the Texas sun.\n\nDesigned with a community focus, our apartments feature a Rooftop Sky Lounge with breathtaking views of Downtown Dallas, giving you a taste of urban elegance. Residents also enjoy our Social Lounge, equipped with roll-up 'garage' doors that open up to the pool area, creating a seamless indoor-outdoor experience. Join us in elevating your lifestyle in one of the most sought-after neighborhoods in Dallas.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort Style Pool Apartments Downtown Dallas",
      "seo_description": "Explore resort style pool apartments in Dallas Downtown Historic District at Skyline Farmers Market. Enjoy luxury amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "rooftop-sky-lounge-apartments-with-downtown-dallas-views",
      "search_query": "rooftop sky lounge apartments with Downtown Dallas views",
      "category": "Amenity",
      "h1_title": "Rooftop Sky Lounge Apartments with Scenic Views",
      "h2_subtitle": "Live in luxury at our rooftop sky lounge apartments. Enjoy stunning Downtown Dallas views and premium amenities for a vibrant lifestyle.",
      "page_copy": "Experience unparalleled urban living at Skyline Farmers Market, where our rooftop sky lounge apartments offer mesmerizing views of Downtown Dallas. Located in the Dallas Downtown Historic District, these apartments boast a unique blend of history and modern convenience. Our rooftop Sky Lounge provides the perfect setting for relaxation and entertainment, offering panoramic views that capture the essence of this bustling city.\n\nResidents are treated to luxurious amenities including a resort-style pool with a sundeck and a Social Lounge that opens onto the pool area. These spaces are designed to enhance social interaction and create lasting memories. With our prime location, everything downtown has to offer is right at your doorstep, making it easy to explore the vibrant culture and dining opportunities in the area. Choose Skyline Farmers Market for a sophisticated lifestyle with unbeatable views.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rooftop Sky Lounge Apartments in Dallas",
      "seo_description": "Discover stunning Downtown Dallas views from our rooftop sky lounge apartments at Skyline Farmers Market. Enjoy luxury and prime location living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "apartments-with-fitness-centers-overlooking-pools-dallas",
      "search_query": "apartments with fitness centers overlooking pools Dallas",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments Overlooking Pools",
      "h2_subtitle": "Find apartments with fitness centers overlooking pools in Dallas. Enjoy the perfect blend of exercise and relaxation within our luxurious community.",
      "page_copy": "At Skyline Farmers Market, you can find apartments that combine luxury and wellness, right in the heart of Dallas. While we pride ourselves on offering a stunning resort-style pool with a sundeck, our soon-to-come fitness center will further enhance the active lifestyle of our residents. Imagine enjoying an energizing morning workout with views of the shimmering pool, perfectly located within the Dallas Downtown Historic District.\n\nOur community amenities go beyond the ordinary. Residents enjoy access to a Luxor Package Locker for secure and free package handling, a Social Lounge complete with roll-up 'garage' doors opening onto the pool area, and a Rooftop Sky Lounge offering breathtaking vistas of Downtown Dallas. Skyline Farmers Market offers not just a place to live, but a community that fosters balance and relaxation amidst urban vibrancy.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dallas Apartments with Fitness Centers & Pools",
      "seo_description": "Discover apartments in Dallas with fitness centers overlooking pools at Skyline Farmers Market. Enjoy luxury amenities and a vibrant downtown lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "apartments-with-electric-vehicle-charging-stations-dallas-tx",
      "search_query": "apartments with electric vehicle charging stations Dallas TX",
      "category": "Amenity",
      "h1_title": "Dallas Apartments with EV Charging Stations",
      "h2_subtitle": "Explore apartments with electric vehicle charging stations in Dallas, TX. Perfect for eco-friendly residents seeking convenience and modern living.",
      "page_copy": "Skyline Farmers Market is at the forefront of sustainable living in Dallas, offering residents modern amenities including electric vehicle charging stations. Located in the vibrant Dallas Downtown Historic District, our community is perfectly aligned with the needs of the environmentally conscious urbanite. Our commitment to a greener lifestyle is reflected in every aspect of our community, supporting residents who drive electric vehicles.\n\nFor those looking to enjoy urban luxury, our apartments come equipped with a Rooftop Sky Lounge, providing stunning views of Downtown Dallas, and a resort-style pool with a sundeck for relaxation. Residents also benefit from a Social Lounge that invites mingling and connection among neighbors. By choosing Skyline Farmers Market, you're not only opting for convenience and sophistication but also actively supporting eco-friendly initiatives.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dallas TX EV Charging Apartments",
      "seo_description": "Discover Dallas TX apartments with electric vehicle charging stations at Skyline Farmers Market. Enjoy modern amenities and eco-friendly living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "social-lounge-apartments-near-dallas-county",
      "search_query": "social lounge apartments near Dallas County",
      "category": "Amenity",
      "h1_title": "Social Lounge Apartments Near Dallas County",
      "h2_subtitle": "Experience vibrant social living in apartments near Dallas County. Our inviting social lounge is perfect for gatherings in a lively community.",
      "page_copy": "Skyline Farmers Market is the ideal choice for those seeking a community-focused lifestyle with our state-of-the-art social lounge apartments near Dallas County. Located in the heart of the Dallas Downtown Historic District, our complex invites residents to enjoy camaraderie and connection. The social lounge is designed with roll-up 'garage' doors that open onto the resort-style pool area, creating an indoor-outdoor living experience perfect for gatherings and relaxation.\n\nBeyond the social lounge, our residents benefit from luxurious amenities like a Rooftop Sky Lounge with breathtaking views of Downtown Dallas and a Luxor Package Locker for convenient package management. Whether you're lounging by the pool or taking in the city skyline, Skyline Farmers Market offers a welcoming environment that fosters community interaction and modern urban living. Choose our apartments for a central location and vibrant social scene.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dallas County Social Lounge Apartments",
      "seo_description": "Find social lounge apartments near Dallas County at Skyline Farmers Market. Enjoy community living with modern amenities and a central location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "studio-apartments-dallas-downtown-historic-district",
      "search_query": "studio apartments in Dallas Downtown Historic District",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Downtown Dallas",
      "h2_subtitle": "Discover premier studio apartments in the Dallas Downtown Historic District. Experience urban living with modern conveniences and stylish spaces.",
      "page_copy": "Nestled in the heart of the Dallas Downtown Historic District, Skyline Farmers Market offers stylish studio apartments perfect for those seeking a vibrant city lifestyle. Our studios are designed to maximize space and comfort, providing a modern living experience in one of Dallas's most coveted neighborhoods. Each apartment is just steps away from a bustling urban scene, full of culture, dining, and entertainment options.\n\nResidents enjoy a host of exclusive amenities that enhance everyday living. Whether you're relaxing in our resort-style pool with a sundeck, mingling in the Social Lounge, or enjoying breathtaking views from the Rooftop Sky Lounge, Skyline Farmers Market offers a seamless blend of comfort and city living. With features like a Luxor Package Locker system, you'll also enjoy convenient access to your deliveries. Experience the best of downtown Dallas by making one of our studio apartments your home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Historic Downtown Dallas",
      "seo_description": "Find stylish studio apartments in the Dallas Downtown Historic District at Skyline Farmers Market. Enjoy modern amenities and vibrant urban living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-near-75226",
      "search_query": "one bedroom apartments near 75226",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Near 75226",
      "h2_subtitle": "Explore modern one bedroom apartments near 75226 in Dallas. Enjoy urban convenience and a variety of top-notch amenities.",
      "page_copy": "Discover the perfect blend of comfort and style with one bedroom apartments at Skyline Farmers Market, conveniently located near the 75226 area. Situated in the lively Dallas Downtown Historic District, our community offers residents unparalleled urban living with easy access to a variety of shopping, dining, and cultural options. Each one bedroom apartment is thoughtfully designed to maximize living space, ensuring you have everything you need for a comfortable lifestyle.\n\nSkyline Farmers Market takes pride in offering exceptional amenities that enhance daily living. Enjoy the luxurious atmosphere of our Rooftop Sky Lounge with spectacular views of Downtown Dallas, or relax by the resort-style pool and sundeck. The Social Lounge, with its roll-up 'garage' doors, offers a festive atmosphere perfect for meeting neighbors. Plus, our Luxor Package Locker makes receiving packages a breeze. Experience modern living at its finest by choosing our one bedroom apartments near 75226.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Near 75226",
      "seo_description": "Find modern one bedroom apartments near 75226 at Skyline Farmers Market. Enjoy top-notch amenities and convenient urban living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-dallas-county",
      "search_query": "two bedroom apartments in Dallas County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Dallas County",
      "h2_subtitle": "Discover spacious two bedroom apartments in Dallas County. Enjoy comfortable living with premium amenities and a central location.",
      "page_copy": "Skyline Farmers Market presents exquisite two bedroom apartments designed for those seeking ample space and modern amenities in Dallas County. Perfectly located in the vibrant Dallas Downtown Historic District, our community offers a unique blend of urban excitement and residential tranquility. Each apartment is crafted to provide an open and adaptable living environment, catering to both entertainment and quiet relaxation.\n\nResidents at Skyline Farmers Market benefit from a range of extraordinary amenities. Take in the stunning cityscape from our Rooftop Sky Lounge or unwind by the resort-style pool equipped with a sundeck. The Social Lounge, featuring roll-up 'garage' doors to the pool area, provides an ideal setting for social occasions. Our Luxor Package Locker system ensures a hassle-free way to manage deliveries. Choose our two bedroom apartments in Dallas County and enjoy the perfect mix of comfort and convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Dallas County",
      "seo_description": "Find spacious two bedroom apartments in Dallas County at Skyline Farmers Market. Enjoy modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "apartments-near-SMU-dallas",
      "search_query": "apartments near southern methodist university dallas",
      "category": "School",
      "h1_title": "Apartments Near SMU Dallas",
      "h2_subtitle": "Find exceptional apartments near Southern Methodist University in Dallas. Experience convenient living with luxury amenities.",
      "page_copy": "Skyline Farmers Market offers ideal living options for those seeking apartments near Southern Methodist University in Dallas. Located in the bustling Dallas Downtown Historic District, our community provides residents easy access to both SMU and the vibrant heartbeat of the city. Whether you're a student or a professional, our apartments offer stylish, convenient, and comfortable living to enhance your Dallas experience.\n\nResidents enjoy premier amenities designed to enrich daily life. Relax in our resort-style pool with a sundeck or take in breathtaking views from our Rooftop Sky Lounge. The Social Lounge, featuring roll-up 'garage' doors to the pool area, is perfect for casual get-togethers. For your convenience, all residents have access to the Luxor Package Locker system, ensuring easy and secure parcel delivery. Choose Skyline Farmers Market for an unparalleled living experience near SMU.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Southern Methodist University",
      "seo_description": "Discover apartments near Southern Methodist University at Skyline Farmers Market. Enjoy premier amenities and convenient living in Dallas.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "apartments-close-to-TWU-downtown-historic-district",
      "search_query": "apartments close to texas woman's university downtown historic district",
      "category": "School",
      "h1_title": "Apartments Near TWU Downtown Historic",
      "h2_subtitle": "Explore apartments close to Texas Woman's University in the Downtown Historic District. Enjoy a vibrant lifestyle with luxury amenities.",
      "page_copy": "Located near the iconic Texas Woman's University, Skyline Farmers Market offers exceptional apartments within the downtown historic district of Dallas. Our community is perfectly situated for those seeking a dynamic urban environment coupled with academic convenience. These apartments are designed to provide an inviting living space, ideal for students, faculty, and those who appreciate proximity to cultural landmarks.\n\nSkyline Farmers Market enhances your living experience with outstanding amenities. Unwind with friends at the resort-style pool or soak in scenic city views from our Rooftop Sky Lounge. Our Social Lounge, equipped with roll-up 'garage' doors, creates the perfect venue for social events. Additionally, our Luxor Package Locker ensures that receiving deliveries is hassle-free. Experience the best in Dallas living close to Texas Woman's University in the downtown historic district.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Texas Woman's University Downtown",
      "seo_description": "Find apartments near Texas Woman's University in the Downtown Historic District at Skyline Farmers Market with top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "apartments-near-dallas-college-el-centro-campus",
      "search_query": "apartments by dallas college el centro campus 75226",
      "category": "School",
      "h1_title": "Apts by Dallas College El Centro Campus",
      "h2_subtitle": "Discover apartments conveniently located by Dallas College El Centro Campus, zip code 75226. Enjoy modern living in the heart of Dallas.",
      "page_copy": "Skyline Farmers Market presents the perfect place for those seeking apartments by Dallas College El Centro Campus, located in the lively area of zip code 75226. Situated in the vibrant core of Dallas, our community offers residents convenient access to academic pursuits along with the city's plethora of dining, shopping, and entertainment options. Designed with both convenience and comfort in mind, our apartments provide a welcoming retreat in the busy downtown scene.\n\nBoasting a variety of upscale amenities, residents can enjoy leisure and relaxation without leaving the community. Unwind by our resort-style pool with its inviting sundeck or soak up the panoramic views of Dallas from the Rooftop Sky Lounge. The Social Lounge, which opens onto the pool through roll-up 'garage' doors, is ideal for hosting gatherings. Plus, our Luxor Package Locker makes receiving parcels easy and secure. Skyline Farmers Market delivers sophisticated living near Dallas College El Centro Campus.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Dallas College El Centro Campus",
      "seo_description": "Explore apartments near Dallas College El Centro Campus in 75226 at Skyline Farmers Market, where modern amenities meet urban convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "apartments-near-childrens-medical-center-dallas",
      "search_query": "apartments near children's medical center dallas",
      "category": "Hospital",
      "h1_title": "Apts Near Children's Medical Center Dallas",
      "h2_subtitle": "Discover spacious apartments near Children's Medical Center Dallas. Enjoy convenient living with premium amenities and downtown access.",
      "page_copy": "Skyline Farmers Market is the ideal choice for those looking for apartments near Children's Medical Center Dallas. Located in the vibrant downtown historic district, our community offers easy access to the hospital alongside the bustling energy of Dallas city life. Ideal for healthcare professionals, patients, and families, our apartments promise a comfortable and convenient living experience.\n\nResidents can indulge in a variety of luxurious amenities, designed to provide relaxation and enjoyment. The resort-style pool with a sundeck is perfect for unwinding, while the Rooftop Sky Lounge offers breathtaking views of Downtown Dallas. The Social Lounge, equipped with roll-up 'garage' doors, creates an inviting atmosphere for social gatherings. Plus, the Luxor Package Locker ensures secure and convenient parcel deliveries. Choose Skyline Farmers Market for a superior living experience near Children's Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Children's Medical Center Dallas",
      "seo_description": "Find comfortable apartments near Children's Medical Center Dallas at Skyline Farmers Market, featuring great amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "apartments-close-to-parkland-health-dallas-downtown",
      "search_query": "apartments close to parkland health dallas downtown",
      "category": "Hospital",
      "h1_title": "Apts Close to Parkland Health Dallas Downtown",
      "h2_subtitle": "Discover convenient living with apartments close to Parkland Health in Dallas Downtown. Experience top amenities and vibrant city life.",
      "page_copy": "Skyline Farmers Market offers exceptional living options for those seeking apartments close to Parkland Health Dallas in the downtown area. Ideally situated in the Dallas Downtown Historic District, our location combines convenience with dynamic city amenities, making it a prime choice for healthcare professionals and residents who value urban accessibility.\n\nEnjoy a lifestyle of luxury with our impressive amenities. Take a dip in our resort-style pool or relax on the sundeck. For stunning vistas, our Rooftop Sky Lounge provides unparalleled views of Dallas's skyline. The Social Lounge is perfect for gatherings, featuring unique roll-up 'garage' doors leading to the pool area. Additionally, our Luxor Package Locker system ensures package deliveries are hassle-free and secure. Choose Skyline Farmers Market for a vibrant and comfortable home near Parkland Health in downtown Dallas.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Parkland Health Dallas Downtown",
      "seo_description": "Explore luxury apartments near Parkland Health Dallas Downtown. Skyline Farmers Market offers top amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "apartments-near-dallas-arboretum-and-botanical-garden",
      "search_query": "apartments near The Dallas Arboretum and Botanical Garden",
      "category": "Park",
      "h1_title": "Apts Near Dallas Arboretum & Botanical Garden",
      "h2_subtitle": "Discover charming apartments near The Dallas Arboretum and Botanical Garden. Enjoy easy access to natural beauty and modern conveniences.",
      "page_copy": "For those seeking a harmonious blend of nature and urban life, Skyline Farmers Market provides ideal apartments near The Dallas Arboretum and Botanical Garden. Located in the lively Dallas Downtown Historic District, residents can enjoy the vibrancy of city life while being just a short drive from the tranquil beauty of the Arboretum. Experience the best of both worlds with our impressive amenities and prime location.\n\nOur community features a rooftop Sky Lounge offering stunning views of the Dallas skyline, complementing your lifestyle with its elegant design. Whether lounging by the resort-style pool or hosting gatherings in the Social Lounge with its unique roll-up 'garage' doors, you'll find plenty of ways to relax and socialize. Each apartment is equipped with a Luxor Package Locker, making mail and package retrieval easy and secure. Embrace the vibrant city life while staying close to nature at Skyline Farmers Market.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Dallas Arboretum & Botanical Garden",
      "seo_description": "Live near The Dallas Arboretum and Botanical Garden. Skyline Farmers Market offers modern apartments with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "skyline-living-close-to-klyde-warren-park",
      "search_query": "Skyline living close to Klyde Warren Park",
      "category": "Park",
      "h1_title": "Skyline Living Near Klyde Warren Park",
      "h2_subtitle": "Experience the best of skyline living close to Klyde Warren Park. Our prime location offers access to urban amenities and serene park spaces.",
      "page_copy": "At Skyline Farmers Market, embrace skyline living close to Klyde Warren Park, where urban excitement meets peaceful park retreats. Set in the renowned Dallas Downtown Historic District, our community offers residents unmatched access to one of Dallas's premier green spaces while indulging in the luxuries of stunning downtown living.\n\nOur sophisticated amenities are designed to complement this unique lifestyle. The Rooftop Sky Lounge presents stunning panoramic views of Downtown Dallas, perfect for relaxing or entertaining guests. Our resort-style pool, complete with a sun-soaked sundeck, is a haven for those warm Texas days. Residents appreciate the convenience of the Luxor Package Locker system, ensuring secure and easy package pickups. At Skyline Farmers Market, blend the vibrancy of downtown with the tranquility of Klyde Warren Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Skyline Living Near Klyde Warren Park",
      "seo_description": "Enjoy skyline living close to Klyde Warren Park at Skyline Farmers Market. Discover urban luxury with park-like serenity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "apartments-dallas-county-by-fair-park",
      "search_query": "apartments in Dallas County by Fair Park",
      "category": "Park",
      "h1_title": "Apts in Dallas County Near Fair Park",
      "h2_subtitle": "Find ideal apartments in Dallas County by Fair Park. Experience urban living combined with convenient access to one of Dallas's top attractions.",
      "page_copy": "Discover the perfect blend of comfort and convenience at Skyline Farmers Market, offering apartments in Dallas County by Fair Park. Positioned in the vibrant Dallas Downtown Historic District, our location ensures you're never far from the excitement and events hosted at Fair Park, while enjoying the comforts of modern living.\n\nOur community boasts a range of high-end amenities that enhance your living experience. Enjoy sweeping views from our Rooftop Sky Lounge or unwind by the resort-style pool with an expansive sundeck. The Social Lounge, with its unique roll-up 'garage' doors, provides a welcoming atmosphere for gatherings. Plus, the Luxor Package Locker ensures that receiving your packages is always stress-free. Choose Skyline Farmers Market for its unparalleled access to Fair Park and a lively downtown lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Fair Park in Dallas County",
      "seo_description": "Explore luxury apartments by Fair Park in Dallas County at Skyline Farmers Market. Enjoy modern amenities and prime location near top attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "living-near-dealey-plaza-dallas-historic-district",
      "search_query": "Dallas Downtown Historic District living near Dealey Plaza",
      "category": "Park",
      "h1_title": "Historic Living Near Dealey Plaza",
      "h2_subtitle": "Experience the charm of Dallas Downtown Historic District living near Dealey Plaza. Our location blends history with modern conveniences.",
      "page_copy": "At Skyline Farmers Market, experience Dallas Downtown Historic District living near Dealey Plaza, where history becomes part of your everyday life. Set in a neighborhood known for its rich cultural heritage, residents enjoy a unique blend of past and present, just a short walk from the iconic Dealey Plaza.\n\nOur community offers a range of luxurious amenities designed for modern lifestyles. Take in breathtaking views of the city from our Rooftop Sky Lounge or relax poolside at our resort-style pool, complete with a sun-drenched sundeck. The Social Lounge, featuring distinctive roll-up 'garage' doors, creates a perfect atmosphere for socializing with friends and neighbors. With the convenience of our Luxor Package Locker, you'll have peace of mind knowing your deliveries are safe and accessible. Choose Skyline Farmers Market for a lifestyle that combines the historical charm of Dallas with contemporary living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Historic Living Near Dealey Plaza",
      "seo_description": "Live in the Dallas Downtown Historic District near Dealey Plaza. Skyline Farmers Market offers modern amenities with historical charm.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "apartments-near-pioneer-plaza-dallas-tx",
      "search_query": "apartments near Pioneer Plaza in Dallas TX",
      "category": "Park",
      "h1_title": "Apts Near Pioneer Plaza, Dallas, TX",
      "h2_subtitle": "Discover premier apartments near Pioneer Plaza in Dallas, TX. Enjoy modern comforts in a vibrant urban setting with easy access to iconic landmarks.",
      "page_copy": "Positioned in the heart of the action, Skyline Farmers Market offers luxurious apartments near Pioneer Plaza in Dallas, TX. Residents are steps away from one of Dallas's most celebrated landmarks, with its remarkable sculptures and lush green spaces, creating a perfect balance of urban and natural appeal.\n\nOur community features upscale amenities catering to the modern lifestyle. Savor stunning views from our enchanting Rooftop Sky Lounge or unwind by the sparkling resort-style pool, equipped with a sun-drenched sundeck for your relaxation. The innovative Social Lounge, featuring roll-up 'garage' doors, offers the perfect backdrop for social gatherings. You’ll also appreciate the convenience of the Luxor Package Locker, ensuring seamless package retrieval. At Skyline Farmers Market, experience a lifestyle that combines proximity to iconic Dallas sites with exceptional community living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Pioneer Plaza, Dallas TX",
      "seo_description": "Explore apartments near Pioneer Plaza in Dallas, TX at Skyline Farmers Market, where luxury meets city living with premier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "apartments-near-akard-dallas",
      "search_query": "apartments near Akard Dallas",
      "category": "Transit",
      "h1_title": "Apts Near Akard Station, Dallas",
      "h2_subtitle": "Explore luxurious apartments near Akard in Dallas. Enjoy modern living with easy access to transportation and urban conveniences.",
      "page_copy": "Skyline Farmers Market offers luxurious apartments near Akard Station in the vibrant heart of Dallas. Our prime location ensures quick and convenient access to Dallas's transit network, making commuting and exploring the city a breeze. Living near Akard means being connected to all the excitement and opportunities that Downtown Dallas has to offer.\n\nOur community is more than just a place to live; it's a lifestyle. Relax and take in the breathtaking city views from our Rooftop Sky Lounge or lounge by the stunning resort-style pool complete with an inviting sundeck. The Social Lounge, featuring unique roll-up 'garage' doors, is perfect for hosting gatherings or meeting new friends. Additionally, the Luxor Package Locker provides secure and efficient package management. Choose Skyline Farmers Market for unparalleled convenience and comfort near Akard Station in Dallas.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Akard Station, Dallas",
      "seo_description": "Find luxurious apartments near Akard Station, Dallas at Skyline Farmers Market. Enjoy seamless city living with top-tier amenities and easy transit access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "skyline-farmers-market-near-pearl-arts-district",
      "search_query": "Skyline Farmers Market near Pearl/Arts District Station",
      "category": "Transit",
      "h1_title": "Skyline Market Near Pearl/Arts District",
      "h2_subtitle": "Discover Skyline Farmers Market near Pearl/Arts District Station, offering urban living with unmatched access to Dallas's cultural heart.",
      "page_copy": "Nestled near the vibrant Pearl/Arts District Station, Skyline Farmers Market presents a unique opportunity for those seeking a blend of culture and modern living. Our apartments offer convenient access to Dallas's acclaimed Arts District, placing world-class museums, theaters, and eateries at your fingertips.\n\nResidents enjoy a range of premium amenities designed for comfort and leisure. Our Rooftop Sky Lounge offers panoramic views of Downtown Dallas, perfect for unwinding after work. Enjoy the sun by our resort-style pool, or socialize with neighbors in the Social Lounge featuring functional roll-up 'garage' doors. With the added convenience of our complimentary Luxor Package Locker system, Skyline Farmers Market ensures contemporary urban living in one of the city's most sought-after areas.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Skyline Market Near Pearl/Arts District",
      "seo_description": "Experience Skyline Farmers Market near Pearl/Arts District Station. Enjoy luxury living with prime access to Dallas's cultural and culinary highlights.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "apartments-close-to-fair-park-station-75226",
      "search_query": "apartments close to Fair Park Station 75226",
      "category": "Transit",
      "h1_title": "Apts Close to Fair Park Station 75226",
      "h2_subtitle": "Find stylish apartments close to Fair Park Station in the 75226 area. Enjoy a community crafted for convenience and modern living.",
      "page_copy": "Located within the zip code 75226, Skyline Farmers Market offers premium apartments close to Fair Park Station, providing unmatched convenience for those who value accessibility. This ideal location places residents just minutes from the cultural and recreational offerings of Fair Park, known for its vibrant festivals and iconic landmarks.\n\nResidents are welcomed into a community featuring exceptional amenities designed for an upscale lifestyle. Unwind in our Rooftop Sky Lounge, where breathtaking views of Downtown Dallas await. Dive into relaxation at our resort-style pool, complete with a sun-soaked sundeck perfect for lounging. Our Social Lounge, elegantly designed with roll-up 'garage' doors, creates an inviting space for socializing or leisure. Plus, our complimentary Luxor Package Locker ensures seamless package deliveries, enhancing your living experience. Choose Skyline Farmers Market for unparalleled proximity and luxury living near Fair Park Station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Fair Park Station 75226",
      "seo_description": "Explore luxury apartments near Fair Park Station in 75226 at Skyline Farmers Market. Enjoy prime location and top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449166060",
      "source": "generator",
      "page_item_url": "skyline-farmers-market-near-st-paul-station-dallas-county",
      "search_query": "Skyline Farmers Market near St Paul Station Dallas County",
      "category": "Transit",
      "h1_title": "Skyline Market Near St Paul Station",
      "h2_subtitle": "Explore Skyline Farmers Market near St Paul Station in Dallas County. Enjoy urban living with easy access to Dallas’s transit and attractions.",
      "page_copy": "Situated in the lively Dallas County, Skyline Farmers Market is an excellent choice for those looking to reside near St Paul Station. This prime location provides convenient access to public transit, connecting residents easily to the diverse culture and vibrant life of downtown Dallas.\n\nOur community is crafted with modern amenities that elevate urban living. Residents can relax in style at our Rooftop Sky Lounge while taking in spectacular views of the Dallas skyline. Whether enjoying the sun at our resort-style pool with a spacious sundeck or socializing in our unique Social Lounge with roll-up “garage” doors, there's always something to do. Additionally, with our no-cost Luxor Package Locker system, managing deliveries is seamless. Experience a blend of convenience and luxury at Skyline Farmers Market, perfectly positioned near St Paul Station.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Skyline Market Near St Paul Station",
      "seo_description": "Discover Skyline Farmers Market near St Paul Station in Dallas County. Enjoy luxury living close to transit and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9441272945"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=6128000561"
    },
    {
      "ID": "custom_pay_rent_url",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MSHG5G85"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 6"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "60dacbc4-0b8a-47e7-80cd-2bb5fd7e3a97"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/68e0a7e1-5b2f-4254-be90-e7a67df90d2e/app.js?property=68e0a7e1-5b2f-4254-be90-e7a67df90d2e&propertyName=Skyline+Farmers+Market&channelUuid=2d324c85-507b-11f0-8a1c-42010aa8d42b\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_cort_lead_form_id",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "37512844112"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/60p7k50nw7n"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": null
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6Imw0SWhHSHlreDI5ekZWdm9WbTE0TFE9PSIsInZhbHVlIjoiN0FZTlREQ1lycC9Cd0owVTNSZ1hjQT09IiwibWFjIjoiNDNhOTE4YWE3ZDRjNGVjYThhYTExNzliMmMxOTc5NjNiNGU5NjJmMTc1MWIxYmE5MmQxYTY4YzhjMzdjYzc0OSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "9441272945",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=6128000561",
  "custom_google_gtm_id": "GTM-MSHG5G85",
  "custom_rollout_phase": "Phase 6",
  "custom_rentgrata_token": "60dacbc4-0b8a-47e7-80cd-2bb5fd7e3a97",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/68e0a7e1-5b2f-4254-be90-e7a67df90d2e/app.js?property=68e0a7e1-5b2f-4254-be90-e7a67df90d2e&propertyName=Skyline+Farmers+Market&channelUuid=2d324c85-507b-11f0-8a1c-42010aa8d42b\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "37512844112",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/60p7k50nw7n",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6Imw0SWhHSHlreDI5ekZWdm9WbTE0TFE9PSIsInZhbHVlIjoiN0FZTlREQ1lycC9Cd0owVTNSZ1hjQT09IiwibWFjIjoiNDNhOTE4YWE3ZDRjNGVjYThhYTExNzliMmMxOTc5NjNiNGU5NjJmMTc1MWIxYmE5MmQxYTY4YzhjMzdjYzc0OSJ9",
  "custom_audioeye_site_id": "cb58d100-eb41-4896-bc9a-f04b5bde18be",
  "custom_audioeye_site_hash": "d6e507d815e53c2e475ffc4bf5259a47"
};

export const generatedAt = '2026-11-02T15:45:43.380Z';
